import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import GalaxyLayout from "../../client/components/layout/GalaxyLayout";
import useSocket from "../../../hooks/useSocket";
import "../../../assets/galaxy/RangBaz.css";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";

export default function TP20Galaxy() {
  const [chipActive, setChipActive] = useState(100);
  const [array_list, set_array_list] = useState([]);
  const [betList, setBetList] = useState([]);
  const [gameRoundId, setGameRoundId] = useState("");
  const [resultList, setResultList] = useState([]);
  const dispatch = useDispatch();

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "galaxy",
    type: "tp20_galaxy"
  });
  console.log("Socket data:", data);

  const payloadResult = data?.data?.result;

  let redAPlusOdd = 2;
  let redOdd = 1.98;
  const [redAPlusOddAmount, setRedAPlusOddAmount] = useState(0);
  const [redOddAmount, setRedOddAmount] = useState(0);

  let blueBPlusOdd = 2;
  let blueOdd = 1.98;
  const [blueBPlusOddAmount, setBlueBPlusOddAmount] = useState(0);
  const [blueOddAmount, setBlueOddAmount] = useState(0);

  let allABlack = 1.98;
  let allARed = 1.98;
  const [allABlackAmount, setAllABlackAmount] = useState(0);
  const [allARedAmount, setAllARedAmount] = useState(0);

  let allBBlack = 1.98;
  let allBRed = 1.98;
  const [allBBlackAmount, setAllBBlackAmount] = useState(0);
  const [allBRedAmount, setAllBRedAmount] = useState(0);

  let redGreterThenOdd = 1.95;
  let redEqual = 14;
  let redLessThenOdd = 1.95;
  const [redGreterThenOddAmount, setRedGreterThenOddAmount] = useState(0);
  const [redEqualAmount, setRedEqualAmount] = useState(0);
  const [redLessThenOddAmount, setRedLessThenOddAmount] = useState(0);

  let blueGreterThenOdd = 1.95;
  let blueEqual = 14;
  let blueLessThenOdd = 1.95;
  const [blueGreterThenOddAmount, setBlueGreterThenOddAmount] = useState(0);
  const [blueEqualAmount, setBlueEqualAmount] = useState(0);
  const [blueLessThenOddAmount, setBlueLessThenOddAmount] = useState(0);


  const [redGreaterThan21Win, setRedGreaterThan21Win] = useState(false);
  const [redEqual21Win, setRedEqual21Win] = useState(false);
  const [redLessThan21Win, setRedLessThan21Win] = useState(false);

  const [blueGreaterThan21Win, setBlueGreaterThan21Win] = useState(false);
  const [blueEqual21Win, setBlueEqual21Win] = useState(false);
  const [blueLessThan21Win, setBlueLessThan21Win] = useState(false);

  const [redAWin, setRedAWin] = useState(false);
  const [blueBWin, setBlueBWin] = useState(false);

  const [redAPlusWin, setRedAPlusWin] = useState(false);
  const [blueBPlusWin, setBlueBPlusWin] = useState(false);

  const [allABlackWin, setAllABlackWin] = useState(false);
  const [allARedWin, setAllARedWin] = useState(false);

  const [allBBlackWin, setAllBBlackWin] = useState(false);
  const [allBRedWin, setAllBRedWin] = useState(false);

  let evt_status = "";
  let roundId = "";
  let timeLeft = "";
  let t20Odds = null;
  let ac1 = 1;
  let ac2 = 1;
  let ac3 = 1;
  let bc1 = 1;
  let bc2 = 1;
  let bc3 = 1;
  let eventStatus = "";

  let isCallSend = false;
  let result = "";
  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };


  const getCardValue = (card) => {
    console.log("Card:", card, typeof card);
    if (card == null) return 0;
    card = String(card);
    let value = card.slice(0, -2);
    if (value === "") return Number(card);
    if (value === "A") return 1;
    if (["J", "Q", "K"].includes(value)) return 10;
    return Number(value);
  };
  //const getSuit = (card) => card.slice(-2);

  const getSuit = (card) => {
    console.log("Suit Card:", card, typeof card);
    if (card == null) return "";
    card = String(card);
    return card.slice(-2);
  };

  useEffect(() => {
    if (!data?.data?.data) return;

    clearWinner();

    const odds = data.data.data;

    const cardsReady =
      odds.ac1 !== "1" &&
      odds.ac2 !== "1" &&
      odds.ac3 !== "1" &&
      odds.bc1 !== "1" &&
      odds.bc2 !== "1" &&
      odds.bc3 !== "1";

    if (odds.evt_status !== "CLOSED" || !cardsReady) {
      clearWinner();
      return;
    }

    /*if (odds.evt_status !== "CLOSED") {
      clearWinner();
      return;
    }*/

    //console.log("STATUS:", odds.evt_status);

    /*console.log(
      "Cards:",
      odds.ac1,
      odds.ac2,
      odds.ac3,
      odds.bc1,
      odds.bc2,
      odds.bc3
    );*/

    const aTotal =
      getCardValue(odds.ac1) +
      getCardValue(odds.ac2) +
      getCardValue(odds.ac3);

    const bTotal =
      getCardValue(odds.bc1) +
      getCardValue(odds.bc2) +
      getCardValue(odds.bc3);

    if (aTotal > bTotal) {
      setRedAWin(true);
      setBlueBWin(false);
    } else if (bTotal > aTotal) {
      setBlueBWin(true);
      setRedAWin(false);
    }

    if (aTotal > 21)
      setRedGreaterThan21Win(true);

    if (aTotal === 21)
      setRedEqual21Win(true);

    if (aTotal < 21)
      setRedLessThan21Win(true);
    if (bTotal > 21)
      setBlueGreaterThan21Win(true);

    if (bTotal === 21)
      setBlueEqual21Win(true);

    if (bTotal < 21)
      setBlueLessThan21Win(true);

    const aSuits = [
      getSuit(odds.ac1),
      getSuit(odds.ac2),
      getSuit(odds.ac3)
    ];

    const bSuits = [
      getSuit(odds.bc1),
      getSuit(odds.bc2),
      getSuit(odds.bc3),
    ];

    if (bSuits.every(s => s === "CC" || s === "HH")) {
      setAllBBlackWin(true);
    }

    if (bSuits.every(s => s === "SS" || s === "DD")) {
      setAllBRedWin(true);
    }

    if (aSuits.every(s => s === "CC" || s === "HH")) {
      setAllABlackWin(true);
    }

    if (aSuits.every(s => s === "SS" || s === "DD")) {
      setAllARedWin(true);
    }
    setRedAPlusWin(odds.isPair1 == 1);
    setBlueBPlusWin(odds.isPair2 == 1);

  }, [data]);


  const clearWinner = () => {
    setRedGreaterThan21Win(false);
    setRedEqual21Win(false);
    setRedLessThan21Win(false);

    setBlueGreaterThan21Win(false);
    setBlueEqual21Win(false);
    setBlueLessThan21Win(false);

    setRedAWin(false);
    setBlueBWin(false);

    setRedAPlusWin(false);
    setBlueBPlusWin(false);

    setAllABlackWin(false);
    setAllARedWin(false);

    setAllBBlackWin(false);
    setAllBRedWin(false);
  };

  const placeBet = async () => {
    let totalAmount = 0;
    if (array_list != "" && array_list.length > 0) {
      for (let j = 0; j < array_list.length; j++) {
        let obj = array_list[j];
        totalAmount = totalAmount + obj.amount;
      }
    }
    console.log("totalAmount->", totalAmount);
    console.log("placeBet->", array_list);
    console.log("roundId->", roundId);

    try {
      let betObj = {};
      betObj.game_name = "card2020_galaxy";
      betObj.catmid = roundId;
      betObj.betPlaceArr = array_list;
      betObj.game_type = 10;

      set_array_list([]);

      const response = await axiosInstance.post(
        "/casino/place-bet-casino-multiple",
        betObj
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data?.status !== undefined &&
        response.data?.status !== null
      ) {
        getBetList();
        fetchUserData();
      }
    } catch (error) {
      if (error.response?.data !== undefined && error.response?.data !== null) {
        debugger;
      }
    }
  };

  if (
    data != null &&
    data.data?.data !== null &&
    data.data?.data !== undefined
  ) {
    updateUserData(data?.user);
    t20Odds = data.data.data;
    roundId = t20Odds.cat_mid;
    timeLeft = t20Odds.left_time;
    evt_status = t20Odds.evt_status;
    ac1 = t20Odds.ac1;
    ac2 = t20Odds.ac2;
    ac3 = t20Odds.ac3;
    bc1 = t20Odds.bc1;
    bc2 = t20Odds.bc2;
    bc3 = t20Odds.bc3;

    if (array_list.length > 0 && timeLeft < 5 && !isCallSend) {
      console.log("timeLeft->", timeLeft);
      console.log("roundId->", roundId);
      placeBet();
      isCallSend = true;
    }
  }

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (eventStatus == "CLOSED") {
      resetGame();
    }
  }, [eventStatus]);

  useEffect(() => {
    //setGameRoundId()
    if (gameRoundId == "") {
      setGameRoundId(roundId);
    }
    if (gameRoundId !== roundId) {
      setGameRoundId(roundId);
      resetGame();
    }
    getBetList();
  }, [roundId]);

  const resetGame = () => {
    setChipActive(100);
    setRedAPlusOddAmount(0);
    setRedOddAmount(0);
    setBlueBPlusOddAmount(0);
    setBlueOddAmount(0);
    setAllABlackAmount(0);
    setAllARedAmount(0);
    setAllBBlackAmount(0);
    setAllBRedAmount(0);
    setRedGreterThenOddAmount(0);
    setRedEqualAmount(0);
    setRedLessThenOddAmount(0);
    setBlueGreterThenOddAmount(0);
    setBlueEqualAmount(0);
    setBlueLessThenOddAmount(0);
    setBetList([]);
    isCallSend = false;
    //set_array_list([]);
  };

  const getBetList = async () => {
    if (roundId !== "") {
      try {
        let betObj = {};
        betObj.catmid = roundId;
        betObj.game_name = "card2020_galaxy";
        const response = await axiosInstance.post(
          "/casino/get-casino-bet-list",
          betObj
        );

        setBetList(response.data);
        console.log("betList->", response.data);
      } catch (error) {}
    }
  };

  const undo = () => {
    if (array_list !== null && array_list.length > 0) {
      let firstElement = array_list[0];
      let teamname = firstElement.teamname;

      if (teamname == "greaterthan21a") {
        setRedGreterThenOddAmount(0);
      } else if (teamname == "21yesa") {
        setRedEqualAmount(0);
      } else if (teamname == "lessthan21a") {
        setRedLessThenOddAmount(0);
      } else if (teamname == "Player A Plus") {
        setRedAPlusOddAmount(0);
      } else if (teamname == "Player B Plus") {
        setBlueBPlusOddAmount(0);
      } else if (teamname == "Player A") {
        setRedOddAmount(0);
      } else if (teamname == "Player B") {
        setBlueOddAmount(0);
      } else if (teamname == "greaterThan21B") {
        setBlueGreterThenOddAmount(0);
      } else if (teamname == "21yesB") {
        setBlueEqualAmount(0);
      } else if (teamname == "lessThan21B") {
        setBlueLessThenOddAmount(0);
      } else if (teamname == "ABlack") {
        setAllABlackAmount(0);
      } else if (teamname == "ARed") {
        setAllARedAmount(0);
      } else if (teamname == "BBlack") {
        setAllBBlackAmount(0);
      } else if (teamname == "BRed") {
        setAllBRedAmount(0);
      }

      let newArr = array_list.slice(1);
      set_array_list(newArr);
    }
  };

  const initializeBet = (betType, teamname, type, price) => {
    let amt = 0;
    if (teamname == "greaterthan21a") {
      amt = redGreterThenOddAmount + chipActive;
      setRedGreterThenOddAmount(amt);
    } else if (teamname == "21yesa") {
      amt = redEqualAmount + chipActive;
      setRedEqualAmount(amt);
    } else if (teamname == "lessthan21a") {
      amt = redLessThenOddAmount + chipActive;
      setRedLessThenOddAmount(amt);
    } else if (teamname == "Player A Plus") {
      amt = redAPlusOddAmount + chipActive;
      setRedAPlusOddAmount(amt);
    } else if (teamname == "Player B Plus") {
      amt = blueBPlusOddAmount + chipActive;
      setBlueBPlusOddAmount(amt);
    } else if (teamname == "Player A") {
      amt = redOddAmount + chipActive;
      setRedOddAmount(amt);
    } else if (teamname == "Player B") {
      amt = blueOddAmount + chipActive;
      setBlueOddAmount(amt);
    } else if (teamname == "greaterThan21B") {
      amt = blueGreterThenOddAmount + chipActive;
      setBlueGreterThenOddAmount(amt);
    } else if (teamname == "21yesB") {
      amt = blueEqualAmount + chipActive;
      setBlueEqualAmount(amt);
    } else if (teamname == "lessThan21B") {
      amt = blueLessThenOddAmount + chipActive;
      setBlueLessThenOddAmount(amt);
    } else if (teamname == "ABlack") {
      amt = allABlackAmount + chipActive;
      setAllABlackAmount(amt);
    } else if (teamname == "ARed") {
      amt = allARedAmount + chipActive;
      setAllARedAmount(amt);
    } else if (teamname == "BBlack") {
      amt = allBBlackAmount + chipActive;
      setAllBBlackAmount(amt);
    } else if (teamname == "BRed") {
      amt = allBRedAmount + chipActive;
      setAllBRedAmount(amt);
    }

    let indexFound = -1;

    //console.log("amt->", amt);
    //console.log("before_array_list->", array_list);
    let arr = [];
    if (array_list.length > 0) {
      for (let i = 0; i < array_list.length; i++) {
        let obj = array_list[i];
        if (obj.teamname == teamname) {
          indexFound = i;
          break;
        }
      }

      if (indexFound !== -1) {
        const newArr = array_list.filter((_, index) => index !== indexFound);
        //console.log("newArr->", newArr);
        let obj = {};
        obj.market_type = betType;
        obj.teamname = teamname;
        obj.bettype = type;
        obj.odds = price;
        obj.amount = amt;
        obj.catmid = roundId;
        arr = [...newArr, obj];
        set_array_list(arr);
      } else {
        let objNew = {};
        objNew.market_type = betType;
        objNew.teamname = teamname;
        objNew.bettype = type;
        objNew.odds = price;
        objNew.amount = amt;
        objNew.catmid = roundId;
        arr = [...array_list, objNew];
        set_array_list(arr);
      }
    } else {
      let obj = {};
      obj.market_type = betType;
      obj.teamname = teamname;
      obj.bettype = type;
      obj.odds = price;
      obj.amount = amt;
      obj.catmid = roundId;
      arr = [...array_list, obj];
      set_array_list(arr);
    }

    console.log("arr->", arr);
  };

  return (
    <GalaxyLayout>
      <div className="container mt-4" id="rbc-app">
        <div>
          <div className="tabs-section">
            <ul className="nav nav-tabs mobile-Tab nav-tabs-glxy">
              <li className="nav-item rbc-games-tab" data-id="0">
                <Link className="nav-link active" to="/galaxy-casino/1">
                  <span className="tab-icon">🎮</span>
                  All Games
                  <span className="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li className="nav-item rbc-games-tab" data-id="1">
                <Link className="nav-link" to="/galaxy-casino/2">
                  <span className="tab-icon">🎮</span>
                  Crash
                  <span className="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li className="nav-item rbc-games-tab" data-id="3">
                <Link className="nav-link" to="/galaxy-casino/3">
                  <span className="tab-icon">🎮</span>
                  Card
                  <span className="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>

            <ul className="nav nav-tabs desktop-tab nav-tabs-glxy">
              <li className="nav-item rbc-games-tab" data-id="0">
                <Link className="nav-link active" to="/galaxy-casino/1">
                  <span className="tab-icon">🎮</span>
                  All Games
                  <span className="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li className="nav-item rbc-games-tab" data-id="1">
                <Link className="nav-link" to="/galaxy-casino/2">
                  <span className="tab-icon">🎮</span>
                  Crash
                  <span className="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li className="nav-item rbc-games-tab" data-id="3">
                <Link className="nav-link" to="/galaxy-casino/3">
                  <span className="tab-icon">🎮</span>
                  Card
                  <span className="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>
          </div>

          <div id="rbc-game-view">
            <div className="container-fluid RBC-Jetx-MainContainer">
              <div className="RBC-Jetx-LeftPanel">
                {Object.keys(resultList).map((key) => (
                  <div
                    className="resultbox"
                    style={{
                      backgroundColor:
                        resultList[key] === 1
                          ? "rgb(71 85 105 / 98%)"
                          : "rgb(100 116 139 / 98%)"
                    }}
                  >
                    {resultList[key] === 1 ? "A" : "B"}
                  </div>
                ))}
              </div>

              <div className="RBC-Jetx-CenterPanel">
                <div className="RBC-Jetx-GameScreen B-height scroll-containeraviator-galaxy">
                  <div className="casino-table-galaxy">
                    <div className="casino-hand">
                      <div className="cards-container" id="game-cards1">
                        <span className="card1in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${ac1}.svg`}
                            className="casino-card"
                          />
                        </span>
                        <span className="card2in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${ac2}.svg`}
                            className="casino-card"
                          />
                        </span>
                        <span className="card3in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${ac3}.svg`}
                            className="casino-card"
                          />
                        </span>
                      </div>
                      <div className="runner-name">Player A</div>
                    </div>
                    <div className="casino-hand">
                      <div className="cards-container" id="game-cards2">
                        <span className="card1in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${bc1}.svg`}
                            className="casino-card"
                          />
                        </span>
                        <span className="card2in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${bc2}.svg`}
                            className="casino-card"
                          />
                        </span>
                        <span className="card3in3">
                          <img
                            src={`../assets/galaxy/img/cards3/${bc3}.svg`}
                            className="casino-card"
                          />
                        </span>
                      </div>
                      <div className="runner-name">Player B</div>
                    </div>
                  </div>
                  <div
                    className={
                      evt_status == "OPEN"
                        ? "overlayaviatorx-galaxy"
                        : "overlayaviatorx-galaxy hide"
                    }
                  >
                    <div className="overlay-contentx-galaxy">
                      <span className="overlay-textaviatorx-glaxy">
                        <b style={{ color: "white", fontSize: "18px" }}>
                          Place Bets in <span id="game-time">{timeLeft}</span>
                        </b>
                      </span>
                    </div>
                  </div>
                  <div className="waveStrength-3">
                    <div
                      className="wv4 wave"
                      style={{ borderTopColor: "rgb(192, 192, 192)" }}
                    >
                      <div className="wv3 wave">
                        <div className="wv2 wave">
                          <div className="wv1 wave"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="round-id-container">
                    T20 &nbsp;
                    <span id="round-id">
                      {roundId}- {evt_status}
                    </span>
                    <span className="info-icon openPopUpDetail">ⓘ</span>
                  </div>
                  <div className="Connectedclients-glxy mt-1">
                    <span className="user-icon"></span>{" "}
                    <b>
                      <span id="UsersCount" className="number">
                        60
                      </span>
                    </b>
                  </div>
                </div>
                <div className="relative">
                  <div className="RBC-2-chip-odds-view-ctn-glaxy desktop-tab">
                    <div className="RBC-2-chip-odds-view-layer">
                      <div className="t-l-ctn col-3">
                        <div className="total-bets">
                          <span className="text">Total Bet</span>{" "}
                          <span className="t-count total-bets2">0</span>
                        </div>
                      </div>
                      <div className="chipDeck col-6">
                        <div className="chip-ctn">
                          <div id="fadeIn" className="show-stakes">
                            <div className="chips-layer">
                              <div
                                className={
                                  chipActive === 100
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                                onClick={() => setChipActive(100)}
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt=""
                                  className="chipimg"
                                />{" "}
                                <span className="cdChipSpan" dataval="100">
                                  100
                                </span>
                              </div>
                              <div
                                className={
                                  chipActive === 500
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                                onClick={() => setChipActive(500)}
                              >
                                <img
                                  src="../assets/galaxy/img/chip2.svg"
                                  alt=""
                                  className="chipimg"
                                />{" "}
                                <span className="cdChipSpan" dataval="500">
                                  500
                                </span>
                              </div>
                              <div
                                className={
                                  chipActive === 1000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                                onClick={() => setChipActive(1000)}
                              >
                                <img
                                  src="../assets/galaxy/img/chip3.svg"
                                  alt=""
                                  className="chipimg"
                                />{" "}
                                <span className="cdChipSpan" dataval="1000">
                                  1k
                                </span>
                              </div>
                              <div
                                className={
                                  chipActive === 2000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                                onClick={() => setChipActive(2000)}
                              >
                                <img
                                  src="../assets/galaxy/img/chip4.svg"
                                  alt=""
                                  className="chipimg"
                                />{" "}
                                <span className="cdChipSpan" dataval="2000">
                                  2k
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ure-btn col-3">
                        <div
                          className="undo-ctn undoFunc"
                          style={{ marginLeft: "30px" }}
                          onClick={() => undo()}
                        >
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            className="undo-icon"
                          />
                          <span>Undo</span>
                        </div>
                        <div
                          className="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            className="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="RBC-2-chip-odds-view-ctn-glaxy mobile-View">
                    <div className="RBC-2-chip-odds-view-layer">
                      <div className="t-l-ctn col-12">
                        <div className="total-bets">
                          <span
                            className="text"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            Total Bet
                          </span>{" "}
                          <span
                            className="t-count total-bets2"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            0
                          </span>
                        </div>
                        <div
                          className="undo-ctn undoFunc"
                          style={{ marginLeft: "30px" }}
                          onClick={() => undo()}
                        >
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            className="undo-icon"
                          />
                          <span>Undo</span>
                        </div>
                        <div
                          className="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            className="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                    <div className="chipDeck col-12">
                      <div className="chip-ctn">
                        <div id="fadeIn" className="show-stakes">
                          <div className="chips-layer">
                            <div
                              className={
                                chipActive === 100
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                              onClick={() => setChipActive(100)}
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt=""
                                className="chipimg"
                              />{" "}
                              <span className="cdChipSpan" dataval="100">
                                100
                              </span>
                            </div>
                            <div
                              className={
                                chipActive === 500
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                              onClick={() => setChipActive(500)}
                            >
                              <img
                                src="../assets/galaxy/img/chip2.svg"
                                alt=""
                                className="chipimg"
                              />{" "}
                              <span className="cdChipSpan" dataval="500">
                                500
                              </span>
                            </div>
                            <div
                              className={
                                chipActive === 1000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                              onClick={() => setChipActive(1000)}
                            >
                              <img
                                src="../assets/galaxy/img/chip3.svg"
                                alt=""
                                className="chipimg"
                              />{" "}
                              <span className="cdChipSpan" dataval="1000">
                                1K
                              </span>
                            </div>
                            <div
                              className={
                                chipActive === 2000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                              onClick={() => setChipActive(2000)}
                            >
                              <img
                                src="../assets/galaxy/img/chip4.svg"
                                alt=""
                                className="chipimg"
                              />{" "}
                              <span className="cdChipSpan" dataval="2000">
                                2k
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="flex flex-col gap-half text-white  relative max-w-md mx-auto p-2 rounded-lg"
                    style={{ backgroundColor: "black" }}
                  >
                    <div
                      className="flex gap-half"
                      style={{ backgroundColor: "darkgray" }}
                    >
                      <div
                        className="flex flex-col gap-half"
                        style={{ cursor: "pointer" }}
                      >
                        {/*redGreterThenOdd*/}
                        <div
                          id="greaterThan21ARed"
                          className="relative p-2 border border-transparent bg-gradient-to-t from-red to-redby70 rounded-tl-md span1details"
                          data-teamname="redGreterThenOdd"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet(
                              "f",
                              "greaterthan21a",
                              "b",
                              redGreterThenOdd
                            )
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom left-1by2 p-2p px-1 bg-blackby20 rounded-sm odd">
                            {redGreterThenOdd}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="242"
                              height="121"
                              viewBox="0 0 242 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M81.1818 72.3635L13.5454 99.4544V76.5453L56.6363 61.6362L55.909 62.7271V60.1817L56.6363 61.2726L13.5454 46.3635V23.4544L81.1818 50.5453V72.3635Z"
                                fill="white"
                              ></path>
                              <path
                                d="M99.2118 108V89.8181L133.939 61.0908C136.242 59.1817 138.212 57.3938 139.848 55.7271C141.515 54.0302 142.788 52.2877 143.666 50.4999C144.575 48.712 145.03 46.7271 145.03 44.5453C145.03 42.1514 144.515 40.1059 143.484 38.409C142.484 36.712 141.091 35.409 139.303 34.4999C137.515 33.5605 135.454 33.0908 133.121 33.0908C130.788 33.0908 128.727 33.5605 126.939 34.4999C125.181 35.4393 123.818 36.818 122.848 38.6362C121.878 40.4544 121.394 42.6665 121.394 45.2726H97.3936C97.3936 38.7271 98.8633 33.0908 101.803 28.3635C104.742 23.6362 108.894 19.9999 114.257 17.4544C119.621 14.909 125.909 13.6362 133.121 13.6362C140.575 13.6362 147.03 14.8332 152.484 17.2271C157.969 19.5908 162.197 22.9241 165.166 27.2271C168.166 31.5302 169.666 36.5756 169.666 42.3635C169.666 45.9393 168.924 49.4999 167.439 53.0453C165.954 56.5605 163.288 60.4544 159.439 64.7271C155.591 68.9999 150.121 74.0908 143.03 79.9999L134.303 87.2726V87.8181H170.666V108H99.2118Z"
                                fill="white"
                              ></path>
                              <path
                                d="M228.878 14.909V108H203.605V38.1817H203.06L182.696 50.3635V28.909L205.605 14.909H228.878Z"
                                fill="white"
                              ></path>
                              <path
                                d="M83.5986 78.3975L87.6818 76.762V72.3635V50.5453V46.1468L83.5986 44.5113L15.9622 17.4204L7.04541 13.8489V23.4544V46.3635V50.9926L11.4201 52.5062L37.2825 61.4544L11.4201 70.4026L7.04541 71.9162V76.5453V99.4544V109.06L15.9622 105.488L83.5986 78.3975ZM92.7118 108V114.5H99.2118H170.666H177.166V108V87.8181V81.3181H170.666H151.516C156.723 76.7983 160.993 72.7137 164.269 69.0773C168.382 64.511 171.555 60.0046 173.427 55.5746L173.431 55.5654L173.434 55.5562C175.227 51.2758 176.166 46.8644 176.166 42.3635C176.166 35.3959 174.34 29.0266 170.508 23.524C166.755 18.0901 161.506 14.0405 155.076 11.2662C148.624 8.43835 141.247 7.13623 133.121 7.13623C125.148 7.13623 117.872 8.54423 111.47 11.5821C105.059 14.6248 99.9248 19.074 96.2828 24.9312C92.5974 30.8582 90.8936 37.7304 90.8936 45.2726V51.7726H97.3936H121.394H127.894V45.2726C127.894 43.4573 128.231 42.3551 128.583 41.6951C128.965 40.9803 129.411 40.5531 129.983 40.243C130.702 39.8701 131.69 39.5908 133.121 39.5908C134.565 39.5908 135.559 39.8756 136.279 40.2539L136.318 40.2742L136.357 40.2939C137.062 40.6524 137.525 41.0997 137.884 41.709L137.906 41.7458L137.928 41.7823C138.225 42.271 138.53 43.0951 138.53 44.5453C138.53 45.7949 138.277 46.757 137.872 47.5538L137.852 47.5931L137.833 47.6326C137.313 48.6905 136.483 49.8774 135.211 51.1725L135.21 51.1733C133.766 52.6442 131.97 54.2804 129.794 56.0838C129.793 56.0847 129.792 56.0857 129.791 56.0866L95.0686 84.8096L92.7118 86.7593V89.8181V108ZM235.378 14.909V8.40896H228.878H205.605H203.777L202.216 9.36263L179.307 23.3626L176.196 25.2635V28.909V50.3635V61.8262L186.033 55.9416L197.105 49.3181V108V114.5H203.605H228.878H235.378V108V14.909Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              redGreterThenOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {redGreterThenOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              redGreaterThan21Win
                                ? "zero-value"
                                : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*redEqual*/}
                        <div
                          id="21yesARed"
                          className="relative p-2 border border-transparent bg-gradient-to-t from-red to-redby70 span1details"
                          data-teamname="21yesARed"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet("f", "21yesa", "b", redEqual)
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom left-0.5 p-2p px-1 bg-blackby20 rounded-sm odd">
                            {redEqual}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="158"
                              height="121"
                              viewBox="0 0 158 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M15.182 108V89.8183L49.9092 61.091C52.2123 59.1819 54.182 57.3941 55.8183 55.7274C57.485 54.0304 58.7577 52.288 59.6365 50.5001C60.5456 48.7122 61.0001 46.7274 61.0001 44.5456C61.0001 42.1516 60.485 40.1062 59.4547 38.4092C58.4547 36.7122 57.0607 35.4092 55.2729 34.5001C53.485 33.5607 51.4244 33.091 49.091 33.091C46.7577 33.091 44.6971 33.5607 42.9092 34.5001C41.1516 35.4395 39.788 36.8183 38.8183 38.6365C37.8486 40.4547 37.3638 42.6668 37.3638 45.2728H13.3638C13.3638 38.7274 14.8335 33.091 17.7729 28.3637C20.7123 23.6365 24.8638 20.0001 30.2274 17.4547C35.591 14.9092 41.8789 13.6365 49.091 13.6365C56.5456 13.6365 63.0001 14.8334 68.4547 17.2274C73.9395 19.591 78.1668 22.9244 81.1365 27.2274C84.1365 31.5304 85.6365 36.5759 85.6365 42.3637C85.6365 45.9395 84.8941 49.5001 83.4092 53.0456C81.9244 56.5607 79.2577 60.4547 75.4092 64.7274C71.5607 69.0001 66.091 74.091 59.0001 80.0001L50.2729 87.2728V87.8183H86.6365V108H15.182Z"
                                fill="white"
                              ></path>
                              <path
                                d="M144.848 14.9092V108H119.576V38.1819H119.03L98.6665 50.3638V28.9092L121.576 14.9092H144.848Z"
                                fill="white"
                              ></path>
                              <path
                                d="M8.68195 108V114.5H15.182H86.6365H93.1365V108V87.8183V81.3183H86.6365H67.4862C72.6934 76.7986 76.9636 72.7139 80.2389 69.0775C84.3519 64.5112 87.5257 60.0048 89.3969 55.5749L89.4008 55.5657L89.4047 55.5565C91.1973 51.2761 92.1365 46.8647 92.1365 42.3637C92.1365 35.3956 90.31 29.0258 86.4776 23.5229C82.7243 18.0899 77.4757 14.0407 71.0469 11.2666C64.5944 8.43866 57.2175 7.13647 49.091 7.13647C41.1183 7.13647 33.8419 8.54448 27.4406 11.5824C21.0292 14.6251 15.8949 19.0743 12.2529 24.9315L17.7729 28.3637L12.2529 24.9315C8.5676 30.8584 6.86377 37.7306 6.86377 45.2728V51.7728H13.3638H37.3638H43.8638V45.2728C43.8638 43.4575 44.2016 42.3553 44.5536 41.6953C44.9348 40.9806 45.3812 40.5533 45.9535 40.2433C46.6718 39.8704 47.6606 39.591 49.091 39.591C50.5354 39.591 51.5295 39.8759 52.2495 40.2542L52.288 40.2744L52.3268 40.2941C53.0318 40.6526 53.4957 41.1 53.8547 41.7092L53.8764 41.746L53.8986 41.7826C54.1952 42.2712 54.5001 43.0954 54.5001 44.5456C54.5001 45.7951 54.2476 46.7572 53.8425 47.554L53.8225 47.5933L53.8031 47.6328C53.2831 48.6908 52.4529 49.8777 51.1809 51.1728L51.1802 51.1735C49.7356 52.6448 47.9387 54.2815 45.7625 56.0855C45.762 56.086 45.7615 56.0864 45.761 56.0868L11.0388 84.8098L8.68195 86.7595V89.8183V108ZM151.348 14.9092V8.4092H144.848H121.576H119.747L118.186 9.36287L95.2771 23.3629L92.1665 25.2638V28.9092V50.3638V61.8264L102.003 55.9418L113.076 49.3183V108V114.5H119.576H144.848H151.348V108V14.9092Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              redEqualAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {redEqualAmount}
                            </span>
                          </div>
                          <span
                            className={
                              redEqual21Win ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*redLessThenOdd*/}
                        <div
                          id="lessThan21ARed"
                          className="relative p-2 border border-transparent bg-gradient-to-t from-red to-redby70 span1details"
                          data-teamname="lessThan21ARed"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet(
                              "f",
                              "lessthan21a",
                              "b",
                              redLessThenOdd
                            )
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom left-0.5 p-2p px-1 bg-blackby20 rounded-sm odd">
                            {redLessThenOdd}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="242"
                              height="121"
                              viewBox="0 0 242 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M13.5454 72.3635V50.5453L81.1818 23.4544V46.3635L38.0909 61.2726L38.8181 60.1817V62.7271L38.0909 61.6362L81.1818 76.5453V99.4544L13.5454 72.3635Z"
                                fill="white"
                              ></path>
                              <path
                                d="M99.2118 108V89.8181L133.939 61.0908C136.242 59.1817 138.212 57.3938 139.848 55.7271C141.515 54.0302 142.788 52.2877 143.666 50.4999C144.575 48.712 145.03 46.7271 145.03 44.5453C145.03 42.1514 144.515 40.1059 143.484 38.409C142.484 36.712 141.091 35.409 139.303 34.4999C137.515 33.5605 135.454 33.0908 133.121 33.0908C130.788 33.0908 128.727 33.5605 126.939 34.4999C125.181 35.4393 123.818 36.818 122.848 38.6362C121.878 40.4544 121.394 42.6665 121.394 45.2726H97.3936C97.3936 38.7271 98.8633 33.0908 101.803 28.3635C104.742 23.6362 108.894 19.9999 114.257 17.4544C119.621 14.909 125.909 13.6362 133.121 13.6362C140.575 13.6362 147.03 14.8332 152.484 17.2271C157.969 19.5908 162.197 22.9241 165.166 27.2271C168.166 31.5302 169.666 36.5756 169.666 42.3635C169.666 45.9393 168.924 49.4999 167.439 53.0453C165.954 56.5605 163.288 60.4544 159.439 64.7271C155.591 68.9999 150.121 74.0908 143.03 79.9999L134.303 87.2726V87.8181H170.666V108H99.2118Z"
                                fill="white"
                              ></path>
                              <path
                                d="M228.878 14.909V108H203.605V38.1817H203.06L182.696 50.3635V28.909L205.605 14.909H228.878Z"
                                fill="white"
                              ></path>
                              <path
                                d="M7.04541 72.3635V76.762L11.1286 78.3975L78.7649 105.488L87.6818 109.06V99.4544V76.5453V71.9162L83.3071 70.4026L57.4446 61.4544L83.3071 52.5062L87.6818 50.9926V46.3635V23.4544V13.8489L78.7649 17.4204L11.1286 44.5113L7.04541 46.1468V50.5453V72.3635ZM92.7118 108V114.5H99.2118H170.666H177.166V108V87.8181V81.3181H170.666H151.516C156.723 76.7983 160.993 72.7137 164.269 69.0773C168.382 64.511 171.555 60.0046 173.427 55.5746L173.431 55.5654L173.434 55.5562C175.227 51.2758 176.166 46.8644 176.166 42.3635C176.166 35.3959 174.34 29.0266 170.508 23.524C166.755 18.0901 161.506 14.0405 155.076 11.2662C148.624 8.43835 141.247 7.13623 133.121 7.13623C125.148 7.13623 117.872 8.54423 111.47 11.5821C105.059 14.6248 99.9248 19.074 96.2828 24.9312C92.5974 30.8582 90.8936 37.7304 90.8936 45.2726V51.7726H97.3936H121.394H127.894V45.2726C127.894 43.4573 128.231 42.3551 128.583 41.6951C128.965 40.9803 129.411 40.5531 129.983 40.243C130.702 39.8701 131.69 39.5908 133.121 39.5908C134.565 39.5908 135.559 39.8756 136.279 40.2539L136.318 40.2742L136.357 40.2939C137.062 40.6524 137.525 41.0997 137.884 41.709L137.906 41.7458L137.928 41.7823C138.225 42.271 138.53 43.0951 138.53 44.5453C138.53 45.7949 138.277 46.757 137.872 47.5538L137.852 47.5931L137.833 47.6326C137.313 48.6905 136.483 49.8774 135.211 51.1725L135.21 51.1733C133.766 52.6442 131.97 54.2804 129.794 56.0838C129.793 56.0847 129.792 56.0857 129.791 56.0866L95.0686 84.8096L92.7118 86.7593V89.8181V108ZM235.378 14.909V8.40896H228.878H205.605H203.777L202.216 9.36263L179.307 23.3626L176.196 25.2635V28.909V50.3635V61.8262L186.033 55.9416L197.105 49.3181V108V114.5H203.605H228.878H235.378V108V14.909Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              redLessThenOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {redLessThenOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              redLessThan21Win
                                ? "zero-value"
                                : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>
                      </div>

                      <div
                        className="grid grid-cols-6 w-full gap-half"
                        style={{ cursor: "pointer" }}
                      >
                        {/*redAPlusOdd*/}
                        <div
                          id="aPlus"
                          className="relative  flex items-center justify-center border border-transparent col-span-2 bg-gradient-to-t from-red to-redby70 span1details"
                          data-teamname="Player A Plus"
                          data-bettype="b"
                          data-market-type="m"
                          onClick={() =>
                            initializeBet(
                              "m",
                              "Player A Plus",
                              "b",
                              redAPlusOdd
                            )
                          }
                        >
                          <div className="h-12 w-12 opacity-70">
                            <svg
                              width="189"
                              height="120"
                              viewBox="0 0 189 120"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M46.1819 107H18.9092L49.6365 13.9092H84.1819L114.909 107H87.6365L67.2728 39.5455H66.5455L46.1819 107ZM41.091 70.2728H92.3637V89.1819H41.091V70.2728Z"
                                fill="white"
                              ></path>
                              <path
                                d="M131.577 94.2728V27.0001H151.941V94.2728H131.577ZM108.122 70.8183V50.4546H175.395V70.8183H108.122Z"
                                fill="white"
                              ></path>
                              <path
                                d="M46.1819 113.5H51.0094L52.4045 108.879L56.3885 95.6819H77.4299L81.4138 108.879L82.809 113.5H87.6365H114.909H123.9L121.082 104.963L111.957 77.3183H125.077V94.2728V100.773H131.577H151.941H158.441V94.2728V77.3183H175.395H181.895V70.8183V50.4546V43.9546H175.395H158.441V27.0001V20.5001H151.941H131.577H125.077V27.0001V43.9546H108.122H101.622V46.0092L90.3544 11.8718L88.8813 7.40918H84.1819H49.6365H44.937L43.464 11.8718L12.7367 104.963L9.91873 113.5H18.9092H46.1819ZM67.797 63.7728H66.0214L66.9092 60.832L67.797 63.7728Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>
                          <span className="odd hide">{redAPlusOdd}</span>

                          <div
                            className={
                              redAPlusOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {redAPlusOddAmount}
                            </span>
                          </div>

                          <span
                            className={
                              redAPlusWin ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        <div
                          className="relative flex items-center justify-center border border-transparent col-span-2 bg-gradient-to-t from-purple to-purpleby70"
                          style={{ cursor: "not-allowed", opacity: "0.5" }}
                        >
                          <div className="h-16 w-16 opacity-70">
                            <svg
                              width="336"
                              height="202"
                              viewBox="0 0 336 202"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <mask
                                id="path-1-outside-1_3661_1159"
                                maskUnits="userSpaceOnUse"
                                x="0.877441"
                                y="0.636475"
                                width="336"
                                height="202"
                                fill="black"
                              >
                                <rect
                                  fill="white"
                                  x="0.877441"
                                  y="0.636475"
                                  width="336"
                                  height="202"
                                ></rect>
                                <path d="M99.7754 109.273C92.4421 109.273 85.9269 108.015 80.2299 105.5C74.5633 102.955 70.1087 99.4547 66.8663 95.0001C63.6239 90.5456 61.9875 85.4244 61.9572 79.6365H87.4118C87.4421 81.4244 87.9875 83.0304 89.0481 84.4547C90.139 85.8486 91.6239 86.9395 93.5027 87.7274C95.3815 88.5153 97.533 88.9092 99.9572 88.9092C102.291 88.9092 104.351 88.5001 106.139 87.6819C107.927 86.8334 109.321 85.6668 110.321 84.1819C111.321 82.6971 111.806 81.0001 111.775 79.091C111.806 77.2122 111.23 75.5456 110.048 74.091C108.897 72.6365 107.275 71.5001 105.184 70.6819C103.094 69.8637 100.684 69.4547 97.9572 69.4547H88.5027V52.0001H97.9572C100.472 52.0001 102.684 51.591 104.594 50.7728C106.533 49.9547 108.033 48.8183 109.094 47.3638C110.184 45.9092 110.715 44.2425 110.684 42.3637C110.715 40.5456 110.275 38.9395 109.366 37.5456C108.457 36.1516 107.184 35.0607 105.548 34.2728C103.942 33.485 102.078 33.091 99.9572 33.091C97.6542 33.091 95.5936 33.5001 93.7754 34.3183C91.9875 35.1365 90.5784 36.2728 89.5481 37.7274C88.5178 39.1819 87.9875 40.8486 87.9572 42.7274H63.7754C63.8057 37.0304 65.3663 32.0001 68.4572 27.6365C71.5784 23.2728 75.8511 19.8486 81.2754 17.3637C86.6996 14.8789 92.9269 13.6365 99.9572 13.6365C106.836 13.6365 112.912 14.8031 118.184 17.1365C123.488 19.4698 127.624 22.6819 130.594 26.7728C133.594 30.8334 135.078 35.485 135.048 40.7274C135.109 45.9395 133.321 50.2122 129.684 53.5456C126.078 56.8789 121.503 58.8486 115.957 59.4547V60.1819C123.472 61.0001 129.124 63.3031 132.912 67.091C136.7 70.8486 138.563 75.5759 138.503 81.2728C138.533 86.7274 136.897 91.5607 133.594 95.7728C130.321 99.985 125.76 103.288 119.912 105.682C114.094 108.076 107.381 109.273 99.7754 109.273Z"></path>
                                <path d="M157.307 95.2728V28.0001H177.67V95.2728H157.307ZM133.852 71.8183V51.4547H201.125V71.8183H133.852Z"></path>
                                <path d="M233.94 109.273C226.607 109.273 220.092 108.015 214.395 105.5C208.728 102.955 204.274 99.4547 201.031 95.0001C197.789 90.5456 196.153 85.4244 196.122 79.6365H221.577C221.607 81.4244 222.153 83.0304 223.213 84.4547C224.304 85.8486 225.789 86.9395 227.668 87.7274C229.546 88.5153 231.698 88.9092 234.122 88.9092C236.456 88.9092 238.516 88.5001 240.304 87.6819C242.092 86.8334 243.486 85.6668 244.486 84.1819C245.486 82.6971 245.971 81.0001 245.94 79.091C245.971 77.2122 245.395 75.5456 244.213 74.091C243.062 72.6365 241.44 71.5001 239.349 70.6819C237.259 69.8637 234.849 69.4547 232.122 69.4547H222.668V52.0001H232.122C234.637 52.0001 236.849 51.591 238.759 50.7728C240.698 49.9547 242.198 48.8183 243.259 47.3638C244.349 45.9092 244.88 44.2425 244.849 42.3637C244.88 40.5456 244.44 38.9395 243.531 37.5456C242.622 36.1516 241.349 35.0607 239.713 34.2728C238.107 33.485 236.243 33.091 234.122 33.091C231.819 33.091 229.759 33.5001 227.94 34.3183C226.153 35.1365 224.743 36.2728 223.713 37.7274C222.683 39.1819 222.153 40.8486 222.122 42.7274H197.94C197.971 37.0304 199.531 32.0001 202.622 27.6365C205.743 23.2728 210.016 19.8486 215.44 17.3637C220.865 14.8789 227.092 13.6365 234.122 13.6365C241.001 13.6365 247.077 14.8031 252.349 17.1365C257.653 19.4698 261.789 22.6819 264.759 26.7728C267.759 30.8334 269.243 35.485 269.213 40.7274C269.274 45.9395 267.486 50.2122 263.849 53.5456C260.243 56.8789 255.668 58.8486 250.122 59.4547V60.1819C257.637 61.0001 263.289 63.3031 267.077 67.091C270.865 70.8486 272.728 75.5759 272.668 81.2728C272.698 86.7274 271.062 91.5607 267.759 95.7728C264.486 99.985 259.925 103.288 254.077 105.682C248.259 108.076 241.546 109.273 233.94 109.273Z"></path>
                                <path d="M13.8774 188V118.182H44.1502C49.4684 118.182 53.9343 118.898 57.5479 120.33C61.1843 121.761 63.9229 123.784 65.7638 126.398C67.6274 129.011 68.5593 132.091 68.5593 135.636C68.5593 138.205 67.9911 140.546 66.8547 142.659C65.7411 144.773 64.1729 146.546 62.1502 147.977C60.1274 149.386 57.7638 150.364 55.0593 150.909V151.591C58.0593 151.705 60.7865 152.466 63.2411 153.875C65.6956 155.261 67.6502 157.182 69.1047 159.636C70.5593 162.068 71.2865 164.932 71.2865 168.227C71.2865 172.046 70.2865 175.443 68.2865 178.421C66.3093 181.398 63.4911 183.739 59.832 185.443C56.1729 187.148 51.8093 188 46.7411 188H13.8774ZM32.832 172.864H41.6956C44.8774 172.864 47.2638 172.273 48.8547 171.091C50.4456 169.886 51.2411 168.114 51.2411 165.773C51.2411 164.136 50.8661 162.75 50.1161 161.614C49.3661 160.477 48.2979 159.614 46.9115 159.023C45.5479 158.432 43.9002 158.136 41.9684 158.136H32.832V172.864ZM32.832 146.409H40.6047C42.2638 146.409 43.7297 146.148 45.0024 145.625C46.2752 145.102 47.2638 144.352 47.9684 143.375C48.6956 142.375 49.0593 141.159 49.0593 139.727C49.0593 137.568 48.2865 135.921 46.7411 134.784C45.1956 133.625 43.2411 133.046 40.8774 133.046H32.832V146.409Z"></path>
                                <path d="M138.919 153.091C138.919 160.864 137.407 167.421 134.385 172.761C131.362 178.08 127.282 182.114 122.146 184.864C117.01 187.591 111.282 188.955 104.964 188.955C98.6006 188.955 92.8506 187.58 87.7143 184.83C82.6006 182.057 78.5324 178.011 75.5097 172.693C72.5097 167.352 71.0097 160.818 71.0097 153.091C71.0097 145.318 72.5097 138.773 75.5097 133.455C78.5324 128.114 82.6006 124.08 87.7143 121.352C92.8506 118.602 98.6006 117.227 104.964 117.227C111.282 117.227 117.01 118.602 122.146 121.352C127.282 124.08 131.362 128.114 134.385 133.455C137.407 138.773 138.919 145.318 138.919 153.091ZM119.419 153.091C119.419 148.909 118.862 145.386 117.748 142.523C116.657 139.636 115.032 137.455 112.873 135.977C110.737 134.477 108.101 133.727 104.964 133.727C101.828 133.727 99.1802 134.477 97.0211 135.977C94.8847 137.455 93.2597 139.636 92.1461 142.523C91.0552 145.386 90.5097 148.909 90.5097 153.091C90.5097 157.273 91.0552 160.807 92.1461 163.693C93.2597 166.557 94.8847 168.739 97.0211 170.239C99.1802 171.716 101.828 172.455 104.964 172.455C108.101 172.455 110.737 171.716 112.873 170.239C115.032 168.739 116.657 166.557 117.748 163.693C118.862 160.807 119.419 157.273 119.419 153.091Z"></path>
                                <path d="M201.378 118.182V188H185.56L160.332 151.318H159.923V188H140.969V118.182H157.06L181.878 154.727H182.423V118.182H201.378Z"></path>
                                <path d="M244.942 118.182H263.896V162.909C263.896 168.227 262.624 172.83 260.078 176.716C257.556 180.58 254.033 183.568 249.51 185.682C244.987 187.773 239.737 188.818 233.76 188.818C227.737 188.818 222.465 187.773 217.942 185.682C213.419 183.568 209.896 180.58 207.374 176.716C204.874 172.83 203.624 168.227 203.624 162.909V118.182H222.578V161.273C222.578 163.432 223.056 165.364 224.01 167.068C224.965 168.75 226.283 170.068 227.965 171.023C229.669 171.977 231.601 172.455 233.76 172.455C235.942 172.455 237.874 171.977 239.556 171.023C241.237 170.068 242.556 168.75 243.51 167.068C244.465 165.364 244.942 163.432 244.942 161.273V118.182Z"></path>
                                <path d="M303.821 140C303.639 137.727 302.787 135.955 301.264 134.682C299.764 133.409 297.48 132.773 294.412 132.773C292.458 132.773 290.855 133.011 289.605 133.489C288.378 133.943 287.469 134.568 286.878 135.364C286.287 136.159 285.98 137.068 285.958 138.091C285.912 138.932 286.06 139.693 286.401 140.375C286.764 141.034 287.333 141.636 288.105 142.182C288.878 142.705 289.867 143.182 291.071 143.614C292.276 144.046 293.708 144.432 295.367 144.773L301.094 146C304.958 146.818 308.264 147.898 311.014 149.239C313.764 150.58 316.014 152.159 317.764 153.977C319.514 155.773 320.799 157.796 321.617 160.046C322.458 162.296 322.889 164.75 322.912 167.409C322.889 172 321.742 175.886 319.469 179.068C317.196 182.25 313.946 184.671 309.719 186.33C305.514 187.989 300.458 188.818 294.549 188.818C288.48 188.818 283.185 187.921 278.662 186.125C274.162 184.33 270.662 181.568 268.162 177.841C265.685 174.091 264.435 169.296 264.412 163.455H282.412C282.526 165.591 283.06 167.386 284.014 168.841C284.969 170.296 286.31 171.398 288.037 172.148C289.787 172.898 291.867 173.273 294.276 173.273C296.299 173.273 297.992 173.023 299.355 172.523C300.719 172.023 301.753 171.33 302.458 170.443C303.162 169.557 303.526 168.546 303.549 167.409C303.526 166.341 303.174 165.409 302.492 164.614C301.833 163.796 300.742 163.068 299.219 162.432C297.696 161.773 295.639 161.159 293.049 160.591L286.094 159.091C279.912 157.75 275.037 155.511 271.469 152.375C267.924 149.216 266.162 144.909 266.185 139.455C266.162 135.023 267.344 131.148 269.73 127.83C272.139 124.489 275.469 121.886 279.719 120.023C283.992 118.159 288.889 117.227 294.412 117.227C300.049 117.227 304.924 118.171 309.037 120.057C313.151 121.943 316.321 124.602 318.549 128.034C320.799 131.443 321.935 135.432 321.958 140H303.821Z"></path>
                              </mask>
                              <path
                                d="M99.7754 109.273C92.4421 109.273 85.9269 108.015 80.2299 105.5C74.5633 102.955 70.1087 99.4547 66.8663 95.0001C63.6239 90.5456 61.9875 85.4244 61.9572 79.6365H87.4118C87.4421 81.4244 87.9875 83.0304 89.0481 84.4547C90.139 85.8486 91.6239 86.9395 93.5027 87.7274C95.3815 88.5153 97.533 88.9092 99.9572 88.9092C102.291 88.9092 104.351 88.5001 106.139 87.6819C107.927 86.8334 109.321 85.6668 110.321 84.1819C111.321 82.6971 111.806 81.0001 111.775 79.091C111.806 77.2122 111.23 75.5456 110.048 74.091C108.897 72.6365 107.275 71.5001 105.184 70.6819C103.094 69.8637 100.684 69.4547 97.9572 69.4547H88.5027V52.0001H97.9572C100.472 52.0001 102.684 51.591 104.594 50.7728C106.533 49.9547 108.033 48.8183 109.094 47.3638C110.184 45.9092 110.715 44.2425 110.684 42.3637C110.715 40.5456 110.275 38.9395 109.366 37.5456C108.457 36.1516 107.184 35.0607 105.548 34.2728C103.942 33.485 102.078 33.091 99.9572 33.091C97.6542 33.091 95.5936 33.5001 93.7754 34.3183C91.9875 35.1365 90.5784 36.2728 89.5481 37.7274C88.5178 39.1819 87.9875 40.8486 87.9572 42.7274H63.7754C63.8057 37.0304 65.3663 32.0001 68.4572 27.6365C71.5784 23.2728 75.8511 19.8486 81.2754 17.3637C86.6996 14.8789 92.9269 13.6365 99.9572 13.6365C106.836 13.6365 112.912 14.8031 118.184 17.1365C123.488 19.4698 127.624 22.6819 130.594 26.7728C133.594 30.8334 135.078 35.485 135.048 40.7274C135.109 45.9395 133.321 50.2122 129.684 53.5456C126.078 56.8789 121.503 58.8486 115.957 59.4547V60.1819C123.472 61.0001 129.124 63.3031 132.912 67.091C136.7 70.8486 138.563 75.5759 138.503 81.2728C138.533 86.7274 136.897 91.5607 133.594 95.7728C130.321 99.985 125.76 103.288 119.912 105.682C114.094 108.076 107.381 109.273 99.7754 109.273Z"
                                fill="white"
                              ></path>
                              <path
                                d="M157.307 95.2728V28.0001H177.67V95.2728H157.307ZM133.852 71.8183V51.4547H201.125V71.8183H133.852Z"
                                fill="white"
                              ></path>
                              <path
                                d="M233.94 109.273C226.607 109.273 220.092 108.015 214.395 105.5C208.728 102.955 204.274 99.4547 201.031 95.0001C197.789 90.5456 196.153 85.4244 196.122 79.6365H221.577C221.607 81.4244 222.153 83.0304 223.213 84.4547C224.304 85.8486 225.789 86.9395 227.668 87.7274C229.546 88.5153 231.698 88.9092 234.122 88.9092C236.456 88.9092 238.516 88.5001 240.304 87.6819C242.092 86.8334 243.486 85.6668 244.486 84.1819C245.486 82.6971 245.971 81.0001 245.94 79.091C245.971 77.2122 245.395 75.5456 244.213 74.091C243.062 72.6365 241.44 71.5001 239.349 70.6819C237.259 69.8637 234.849 69.4547 232.122 69.4547H222.668V52.0001H232.122C234.637 52.0001 236.849 51.591 238.759 50.7728C240.698 49.9547 242.198 48.8183 243.259 47.3638C244.349 45.9092 244.88 44.2425 244.849 42.3637C244.88 40.5456 244.44 38.9395 243.531 37.5456C242.622 36.1516 241.349 35.0607 239.713 34.2728C238.107 33.485 236.243 33.091 234.122 33.091C231.819 33.091 229.759 33.5001 227.94 34.3183C226.153 35.1365 224.743 36.2728 223.713 37.7274C222.683 39.1819 222.153 40.8486 222.122 42.7274H197.94C197.971 37.0304 199.531 32.0001 202.622 27.6365C205.743 23.2728 210.016 19.8486 215.44 17.3637C220.865 14.8789 227.092 13.6365 234.122 13.6365C241.001 13.6365 247.077 14.8031 252.349 17.1365C257.653 19.4698 261.789 22.6819 264.759 26.7728C267.759 30.8334 269.243 35.485 269.213 40.7274C269.274 45.9395 267.486 50.2122 263.849 53.5456C260.243 56.8789 255.668 58.8486 250.122 59.4547V60.1819C257.637 61.0001 263.289 63.3031 267.077 67.091C270.865 70.8486 272.728 75.5759 272.668 81.2728C272.698 86.7274 271.062 91.5607 267.759 95.7728C264.486 99.985 259.925 103.288 254.077 105.682C248.259 108.076 241.546 109.273 233.94 109.273Z"
                                fill="white"
                              ></path>
                              <path
                                d="M13.8774 188V118.182H44.1502C49.4684 118.182 53.9343 118.898 57.5479 120.33C61.1843 121.761 63.9229 123.784 65.7638 126.398C67.6274 129.011 68.5593 132.091 68.5593 135.636C68.5593 138.205 67.9911 140.546 66.8547 142.659C65.7411 144.773 64.1729 146.546 62.1502 147.977C60.1274 149.386 57.7638 150.364 55.0593 150.909V151.591C58.0593 151.705 60.7865 152.466 63.2411 153.875C65.6956 155.261 67.6502 157.182 69.1047 159.636C70.5593 162.068 71.2865 164.932 71.2865 168.227C71.2865 172.046 70.2865 175.443 68.2865 178.421C66.3093 181.398 63.4911 183.739 59.832 185.443C56.1729 187.148 51.8093 188 46.7411 188H13.8774ZM32.832 172.864H41.6956C44.8774 172.864 47.2638 172.273 48.8547 171.091C50.4456 169.886 51.2411 168.114 51.2411 165.773C51.2411 164.136 50.8661 162.75 50.1161 161.614C49.3661 160.477 48.2979 159.614 46.9115 159.023C45.5479 158.432 43.9002 158.136 41.9684 158.136H32.832V172.864ZM32.832 146.409H40.6047C42.2638 146.409 43.7297 146.148 45.0024 145.625C46.2752 145.102 47.2638 144.352 47.9684 143.375C48.6956 142.375 49.0593 141.159 49.0593 139.727C49.0593 137.568 48.2865 135.921 46.7411 134.784C45.1956 133.625 43.2411 133.046 40.8774 133.046H32.832V146.409Z"
                                fill="white"
                              ></path>
                              <path
                                d="M138.919 153.091C138.919 160.864 137.407 167.421 134.385 172.761C131.362 178.08 127.282 182.114 122.146 184.864C117.01 187.591 111.282 188.955 104.964 188.955C98.6006 188.955 92.8506 187.58 87.7143 184.83C82.6006 182.057 78.5324 178.011 75.5097 172.693C72.5097 167.352 71.0097 160.818 71.0097 153.091C71.0097 145.318 72.5097 138.773 75.5097 133.455C78.5324 128.114 82.6006 124.08 87.7143 121.352C92.8506 118.602 98.6006 117.227 104.964 117.227C111.282 117.227 117.01 118.602 122.146 121.352C127.282 124.08 131.362 128.114 134.385 133.455C137.407 138.773 138.919 145.318 138.919 153.091ZM119.419 153.091C119.419 148.909 118.862 145.386 117.748 142.523C116.657 139.636 115.032 137.455 112.873 135.977C110.737 134.477 108.101 133.727 104.964 133.727C101.828 133.727 99.1802 134.477 97.0211 135.977C94.8847 137.455 93.2597 139.636 92.1461 142.523C91.0552 145.386 90.5097 148.909 90.5097 153.091C90.5097 157.273 91.0552 160.807 92.1461 163.693C93.2597 166.557 94.8847 168.739 97.0211 170.239C99.1802 171.716 101.828 172.455 104.964 172.455C108.101 172.455 110.737 171.716 112.873 170.239C115.032 168.739 116.657 166.557 117.748 163.693C118.862 160.807 119.419 157.273 119.419 153.091Z"
                                fill="white"
                              ></path>
                              <path
                                d="M201.378 118.182V188H185.56L160.332 151.318H159.923V188H140.969V118.182H157.06L181.878 154.727H182.423V118.182H201.378Z"
                                fill="white"
                              ></path>
                              <path
                                d="M244.942 118.182H263.896V162.909C263.896 168.227 262.624 172.83 260.078 176.716C257.556 180.58 254.033 183.568 249.51 185.682C244.987 187.773 239.737 188.818 233.76 188.818C227.737 188.818 222.465 187.773 217.942 185.682C213.419 183.568 209.896 180.58 207.374 176.716C204.874 172.83 203.624 168.227 203.624 162.909V118.182H222.578V161.273C222.578 163.432 223.056 165.364 224.01 167.068C224.965 168.75 226.283 170.068 227.965 171.023C229.669 171.977 231.601 172.455 233.76 172.455C235.942 172.455 237.874 171.977 239.556 171.023C241.237 170.068 242.556 168.75 243.51 167.068C244.465 165.364 244.942 163.432 244.942 161.273V118.182Z"
                                fill="white"
                              ></path>
                              <path
                                d="M303.821 140C303.639 137.727 302.787 135.955 301.264 134.682C299.764 133.409 297.48 132.773 294.412 132.773C292.458 132.773 290.855 133.011 289.605 133.489C288.378 133.943 287.469 134.568 286.878 135.364C286.287 136.159 285.98 137.068 285.958 138.091C285.912 138.932 286.06 139.693 286.401 140.375C286.764 141.034 287.333 141.636 288.105 142.182C288.878 142.705 289.867 143.182 291.071 143.614C292.276 144.046 293.708 144.432 295.367 144.773L301.094 146C304.958 146.818 308.264 147.898 311.014 149.239C313.764 150.58 316.014 152.159 317.764 153.977C319.514 155.773 320.799 157.796 321.617 160.046C322.458 162.296 322.889 164.75 322.912 167.409C322.889 172 321.742 175.886 319.469 179.068C317.196 182.25 313.946 184.671 309.719 186.33C305.514 187.989 300.458 188.818 294.549 188.818C288.48 188.818 283.185 187.921 278.662 186.125C274.162 184.33 270.662 181.568 268.162 177.841C265.685 174.091 264.435 169.296 264.412 163.455H282.412C282.526 165.591 283.06 167.386 284.014 168.841C284.969 170.296 286.31 171.398 288.037 172.148C289.787 172.898 291.867 173.273 294.276 173.273C296.299 173.273 297.992 173.023 299.355 172.523C300.719 172.023 301.753 171.33 302.458 170.443C303.162 169.557 303.526 168.546 303.549 167.409C303.526 166.341 303.174 165.409 302.492 164.614C301.833 163.796 300.742 163.068 299.219 162.432C297.696 161.773 295.639 161.159 293.049 160.591L286.094 159.091C279.912 157.75 275.037 155.511 271.469 152.375C267.924 149.216 266.162 144.909 266.185 139.455C266.162 135.023 267.344 131.148 269.73 127.83C272.139 124.489 275.469 121.886 279.719 120.023C283.992 118.159 288.889 117.227 294.412 117.227C300.049 117.227 304.924 118.171 309.037 120.057C313.151 121.943 316.321 124.602 318.549 128.034C320.799 131.443 321.935 135.432 321.958 140H303.821Z"
                                fill="white"
                              ></path>
                              <path
                                d="M99.7754 109.273C92.4421 109.273 85.9269 108.015 80.2299 105.5C74.5633 102.955 70.1087 99.4547 66.8663 95.0001C63.6239 90.5456 61.9875 85.4244 61.9572 79.6365H87.4118C87.4421 81.4244 87.9875 83.0304 89.0481 84.4547C90.139 85.8486 91.6239 86.9395 93.5027 87.7274C95.3815 88.5153 97.533 88.9092 99.9572 88.9092C102.291 88.9092 104.351 88.5001 106.139 87.6819C107.927 86.8334 109.321 85.6668 110.321 84.1819C111.321 82.6971 111.806 81.0001 111.775 79.091C111.806 77.2122 111.23 75.5456 110.048 74.091C108.897 72.6365 107.275 71.5001 105.184 70.6819C103.094 69.8637 100.684 69.4547 97.9572 69.4547H88.5027V52.0001H97.9572C100.472 52.0001 102.684 51.591 104.594 50.7728C106.533 49.9547 108.033 48.8183 109.094 47.3638C110.184 45.9092 110.715 44.2425 110.684 42.3637C110.715 40.5456 110.275 38.9395 109.366 37.5456C108.457 36.1516 107.184 35.0607 105.548 34.2728C103.942 33.485 102.078 33.091 99.9572 33.091C97.6542 33.091 95.5936 33.5001 93.7754 34.3183C91.9875 35.1365 90.5784 36.2728 89.5481 37.7274C88.5178 39.1819 87.9875 40.8486 87.9572 42.7274H63.7754C63.8057 37.0304 65.3663 32.0001 68.4572 27.6365C71.5784 23.2728 75.8511 19.8486 81.2754 17.3637C86.6996 14.8789 92.9269 13.6365 99.9572 13.6365C106.836 13.6365 112.912 14.8031 118.184 17.1365C123.488 19.4698 127.624 22.6819 130.594 26.7728C133.594 30.8334 135.078 35.485 135.048 40.7274C135.109 45.9395 133.321 50.2122 129.684 53.5456C126.078 56.8789 121.503 58.8486 115.957 59.4547V60.1819C123.472 61.0001 129.124 63.3031 132.912 67.091C136.7 70.8486 138.563 75.5759 138.503 81.2728C138.533 86.7274 136.897 91.5607 133.594 95.7728C130.321 99.985 125.76 103.288 119.912 105.682C114.094 108.076 107.381 109.273 99.7754 109.273Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M157.307 95.2728V28.0001H177.67V95.2728H157.307ZM133.852 71.8183V51.4547H201.125V71.8183H133.852Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M233.94 109.273C226.607 109.273 220.092 108.015 214.395 105.5C208.728 102.955 204.274 99.4547 201.031 95.0001C197.789 90.5456 196.153 85.4244 196.122 79.6365H221.577C221.607 81.4244 222.153 83.0304 223.213 84.4547C224.304 85.8486 225.789 86.9395 227.668 87.7274C229.546 88.5153 231.698 88.9092 234.122 88.9092C236.456 88.9092 238.516 88.5001 240.304 87.6819C242.092 86.8334 243.486 85.6668 244.486 84.1819C245.486 82.6971 245.971 81.0001 245.94 79.091C245.971 77.2122 245.395 75.5456 244.213 74.091C243.062 72.6365 241.44 71.5001 239.349 70.6819C237.259 69.8637 234.849 69.4547 232.122 69.4547H222.668V52.0001H232.122C234.637 52.0001 236.849 51.591 238.759 50.7728C240.698 49.9547 242.198 48.8183 243.259 47.3638C244.349 45.9092 244.88 44.2425 244.849 42.3637C244.88 40.5456 244.44 38.9395 243.531 37.5456C242.622 36.1516 241.349 35.0607 239.713 34.2728C238.107 33.485 236.243 33.091 234.122 33.091C231.819 33.091 229.759 33.5001 227.94 34.3183C226.153 35.1365 224.743 36.2728 223.713 37.7274C222.683 39.1819 222.153 40.8486 222.122 42.7274H197.94C197.971 37.0304 199.531 32.0001 202.622 27.6365C205.743 23.2728 210.016 19.8486 215.44 17.3637C220.865 14.8789 227.092 13.6365 234.122 13.6365C241.001 13.6365 247.077 14.8031 252.349 17.1365C257.653 19.4698 261.789 22.6819 264.759 26.7728C267.759 30.8334 269.243 35.485 269.213 40.7274C269.274 45.9395 267.486 50.2122 263.849 53.5456C260.243 56.8789 255.668 58.8486 250.122 59.4547V60.1819C257.637 61.0001 263.289 63.3031 267.077 67.091C270.865 70.8486 272.728 75.5759 272.668 81.2728C272.698 86.7274 271.062 91.5607 267.759 95.7728C264.486 99.985 259.925 103.288 254.077 105.682C248.259 108.076 241.546 109.273 233.94 109.273Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M13.8774 188V118.182H44.1502C49.4684 118.182 53.9343 118.898 57.5479 120.33C61.1843 121.761 63.9229 123.784 65.7638 126.398C67.6274 129.011 68.5593 132.091 68.5593 135.636C68.5593 138.205 67.9911 140.546 66.8547 142.659C65.7411 144.773 64.1729 146.546 62.1502 147.977C60.1274 149.386 57.7638 150.364 55.0593 150.909V151.591C58.0593 151.705 60.7865 152.466 63.2411 153.875C65.6956 155.261 67.6502 157.182 69.1047 159.636C70.5593 162.068 71.2865 164.932 71.2865 168.227C71.2865 172.046 70.2865 175.443 68.2865 178.421C66.3093 181.398 63.4911 183.739 59.832 185.443C56.1729 187.148 51.8093 188 46.7411 188H13.8774ZM32.832 172.864H41.6956C44.8774 172.864 47.2638 172.273 48.8547 171.091C50.4456 169.886 51.2411 168.114 51.2411 165.773C51.2411 164.136 50.8661 162.75 50.1161 161.614C49.3661 160.477 48.2979 159.614 46.9115 159.023C45.5479 158.432 43.9002 158.136 41.9684 158.136H32.832V172.864ZM32.832 146.409H40.6047C42.2638 146.409 43.7297 146.148 45.0024 145.625C46.2752 145.102 47.2638 144.352 47.9684 143.375C48.6956 142.375 49.0593 141.159 49.0593 139.727C49.0593 137.568 48.2865 135.921 46.7411 134.784C45.1956 133.625 43.2411 133.046 40.8774 133.046H32.832V146.409Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M138.919 153.091C138.919 160.864 137.407 167.421 134.385 172.761C131.362 178.08 127.282 182.114 122.146 184.864C117.01 187.591 111.282 188.955 104.964 188.955C98.6006 188.955 92.8506 187.58 87.7143 184.83C82.6006 182.057 78.5324 178.011 75.5097 172.693C72.5097 167.352 71.0097 160.818 71.0097 153.091C71.0097 145.318 72.5097 138.773 75.5097 133.455C78.5324 128.114 82.6006 124.08 87.7143 121.352C92.8506 118.602 98.6006 117.227 104.964 117.227C111.282 117.227 117.01 118.602 122.146 121.352C127.282 124.08 131.362 128.114 134.385 133.455C137.407 138.773 138.919 145.318 138.919 153.091ZM119.419 153.091C119.419 148.909 118.862 145.386 117.748 142.523C116.657 139.636 115.032 137.455 112.873 135.977C110.737 134.477 108.101 133.727 104.964 133.727C101.828 133.727 99.1802 134.477 97.0211 135.977C94.8847 137.455 93.2597 139.636 92.1461 142.523C91.0552 145.386 90.5097 148.909 90.5097 153.091C90.5097 157.273 91.0552 160.807 92.1461 163.693C93.2597 166.557 94.8847 168.739 97.0211 170.239C99.1802 171.716 101.828 172.455 104.964 172.455C108.101 172.455 110.737 171.716 112.873 170.239C115.032 168.739 116.657 166.557 117.748 163.693C118.862 160.807 119.419 157.273 119.419 153.091Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M201.378 118.182V188H185.56L160.332 151.318H159.923V188H140.969V118.182H157.06L181.878 154.727H182.423V118.182H201.378Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M244.942 118.182H263.896V162.909C263.896 168.227 262.624 172.83 260.078 176.716C257.556 180.58 254.033 183.568 249.51 185.682C244.987 187.773 239.737 188.818 233.76 188.818C227.737 188.818 222.465 187.773 217.942 185.682C213.419 183.568 209.896 180.58 207.374 176.716C204.874 172.83 203.624 168.227 203.624 162.909V118.182H222.578V161.273C222.578 163.432 223.056 165.364 224.01 167.068C224.965 168.75 226.283 170.068 227.965 171.023C229.669 171.977 231.601 172.455 233.76 172.455C235.942 172.455 237.874 171.977 239.556 171.023C241.237 170.068 242.556 168.75 243.51 167.068C244.465 165.364 244.942 163.432 244.942 161.273V118.182Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                              <path
                                d="M303.821 140C303.639 137.727 302.787 135.955 301.264 134.682C299.764 133.409 297.48 132.773 294.412 132.773C292.458 132.773 290.855 133.011 289.605 133.489C288.378 133.943 287.469 134.568 286.878 135.364C286.287 136.159 285.98 137.068 285.958 138.091C285.912 138.932 286.06 139.693 286.401 140.375C286.764 141.034 287.333 141.636 288.105 142.182C288.878 142.705 289.867 143.182 291.071 143.614C292.276 144.046 293.708 144.432 295.367 144.773L301.094 146C304.958 146.818 308.264 147.898 311.014 149.239C313.764 150.58 316.014 152.159 317.764 153.977C319.514 155.773 320.799 157.796 321.617 160.046C322.458 162.296 322.889 164.75 322.912 167.409C322.889 172 321.742 175.886 319.469 179.068C317.196 182.25 313.946 184.671 309.719 186.33C305.514 187.989 300.458 188.818 294.549 188.818C288.48 188.818 283.185 187.921 278.662 186.125C274.162 184.33 270.662 181.568 268.162 177.841C265.685 174.091 264.435 169.296 264.412 163.455H282.412C282.526 165.591 283.06 167.386 284.014 168.841C284.969 170.296 286.31 171.398 288.037 172.148C289.787 172.898 291.867 173.273 294.276 173.273C296.299 173.273 297.992 173.023 299.355 172.523C300.719 172.023 301.753 171.33 302.458 170.443C303.162 169.557 303.526 168.546 303.549 167.409C303.526 166.341 303.174 165.409 302.492 164.614C301.833 163.796 300.742 163.068 299.219 162.432C297.696 161.773 295.639 161.159 293.049 160.591L286.094 159.091C279.912 157.75 275.037 155.511 271.469 152.375C267.924 149.216 266.162 144.909 266.185 139.455C266.162 135.023 267.344 131.148 269.73 127.83C272.139 124.489 275.469 121.886 279.719 120.023C283.992 118.159 288.889 117.227 294.412 117.227C300.049 117.227 304.924 118.171 309.037 120.057C313.151 121.943 316.321 124.602 318.549 128.034C320.799 131.443 321.935 135.432 321.958 140H303.821Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="26"
                                mask="url(#path-1-outside-1_3661_1159)"
                              ></path>
                            </svg>
                          </div>
                        </div>

                        {/*blueBPlusOdd*/}
                        <div
                          id="bPlus"
                          className="relative  flex items-center justify-center border border-transparent col-span-2 bg-gradient-to-t from-blue to-blueby70 span1details"
                          data-teamname="Player B Plus"
                          data-bettype="b"
                          data-market-type="m"
                          onClick={() =>
                            initializeBet(
                              "m",
                              "Player B Plus",
                              "b",
                              redAPlusOdd
                            )
                          }
                        >
                          <div className="h-12 w-12 opacity-70">
                            <svg
                              width="164"
                              height="120"
                              viewBox="0 0 164 120"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M13 107V13.9092H53.3636C60.4545 13.9092 66.4091 14.8637 71.2273 16.7728C76.0758 18.6819 79.7273 21.3789 82.1818 24.8637C84.6667 28.3486 85.9091 32.4546 85.9091 37.1819C85.9091 40.6061 85.1515 43.7274 83.6364 46.5455C82.1515 49.3637 80.0606 51.7274 77.3636 53.6365C74.6667 55.5152 71.5152 56.8183 67.9091 57.5455V58.4546C71.9091 58.6062 75.5455 59.6213 78.8182 61.5001C82.0909 63.3486 84.697 65.9092 86.6364 69.1819C88.5758 72.4243 89.5455 76.2425 89.5455 80.6365C89.5455 85.7274 88.2121 90.2577 85.5455 94.2274C82.9091 98.1971 79.1515 101.318 74.2727 103.591C69.3939 105.864 63.5758 107 56.8182 107H13ZM38.2727 86.8183H50.0909C54.3333 86.8183 57.5152 86.0304 59.6364 84.4546C61.7576 82.8486 62.8182 80.4849 62.8182 77.3637C62.8182 75.1819 62.3182 73.3334 61.3182 71.8183C60.3182 70.3031 58.8939 69.1516 57.0455 68.3637C55.2273 67.5758 53.0303 67.1819 50.4545 67.1819H38.2727V86.8183ZM38.2727 51.5455H48.6364C50.8485 51.5455 52.803 51.1971 54.5 50.5001C56.197 49.8031 57.5152 48.8031 58.4545 47.5001C59.4242 46.1668 59.9091 44.5455 59.9091 42.6365C59.9091 39.7577 58.8788 37.5607 56.8182 36.0455C54.7576 34.5001 52.1515 33.7274 49 33.7274H38.2727V51.5455Z"
                                fill="white"
                              ></path>
                              <path
                                d="M106.202 94.2728V27.0001H126.565V94.2728H106.202ZM82.7473 70.8183V50.4546H150.02V70.8183H82.7473Z"
                                fill="white"
                              ></path>
                              <path
                                d="M6.5 107V113.5H13H56.8182C64.2888 113.5 71.0886 112.245 77.0175 109.483C82.8313 106.775 87.5705 102.921 90.9506 97.8377C94.3781 92.7293 96.0455 86.9249 96.0455 80.6365C96.0455 79.5138 95.9933 78.407 95.8867 77.3183H99.7018V94.2728V100.773H106.202H126.565H133.065V94.2728V77.3183H150.02H156.52V70.8183V50.4546V43.9546H150.02H133.065V27.0001V20.5001H126.565H106.202H99.7018V27.0001V43.9546H91.575C92.1351 41.7736 92.4091 39.5097 92.4091 37.1819C92.4091 31.2562 90.8298 25.803 87.485 21.1052C84.1524 16.3812 79.3711 12.9948 73.6148 10.7272C67.8115 8.42908 60.9893 7.40918 53.3636 7.40918H13H6.5V13.9092V107ZM48.6364 45.0455H44.7727V40.2274H49C51.0664 40.2274 52.2152 40.7183 52.9182 41.2455L52.9428 41.264L52.9677 41.2823C53.1725 41.4329 53.2221 41.527 53.2514 41.5895C53.2929 41.6781 53.4091 41.9752 53.4091 42.6365C53.4091 43.3871 53.2409 43.6178 53.1993 43.6749L53.1978 43.677L53.1898 43.6879L53.1819 43.6989C53.0487 43.8837 52.7681 44.1845 52.0305 44.4875C51.2605 44.8037 50.1717 45.0455 48.6364 45.0455ZM54.461 74.3278L54.4789 74.3356L54.4968 74.3432C55.3022 74.6865 55.67 75.0605 55.8932 75.3987C56.0611 75.6532 56.3182 76.1946 56.3182 77.3637C56.3182 78.7684 55.9595 79.0848 55.7472 79.2464C55.23 79.6231 53.6871 80.3183 50.0909 80.3183H44.7727V73.6819H50.4545C52.396 73.6819 53.6638 73.9824 54.461 74.3278Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <span className="hides odd">{blueBPlusOdd}</span>
                          <div
                            className={
                              blueBPlusOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {blueBPlusOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              blueBPlusWin ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*redOdd*/}
                        <div
                          id="a"
                          className="relative  flex items-center justify-center border border-transparent col-span-3 bg-gradient-to-t from-red to-redby70 span1details"
                          data-teamname="Player A"
                          data-bettype="b"
                          data-market-type="m"
                          onClick={() =>
                            initializeBet("m", "Player A", "b", redOdd)
                          }
                        >
                          <div className="h-12 w-12 opacity-70">
                            <svg
                              width="133"
                              height="120"
                              viewBox="0 0 133 120"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M46.1819 107H18.9092L49.6365 13.9092H84.1819L114.909 107H87.6365L67.2728 39.5455H66.5455L46.1819 107ZM41.091 70.2728H92.3637V89.1819H41.091V70.2728Z"
                                fill="white"
                              ></path>
                              <path
                                d="M46.1819 113.5H51.0094L52.4045 108.879L56.3885 95.6819H77.4299L81.4138 108.879L82.809 113.5H87.6365H114.909H123.9L121.082 104.963L90.3544 11.8718L88.8813 7.40918H84.1819H49.6365H44.937L43.464 11.8718L12.7367 104.963L9.91873 113.5H18.9092H46.1819ZM66.0214 63.7728L66.9092 60.832L67.797 63.7728H66.0214Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <span className="absolute txt-left-bottom left-0.5 p-2p px-1 bg-blackby20 rounded-sm text-[10px] odd">
                            {redOdd}
                          </span>
                          <div
                            className={
                              redOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {redOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              redEqual21Win ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*blueOdd*/}
                        <div
                          id="b"
                          className="relative  flex items-center justify-center border border-transparent col-span-3 bg-gradient-to-t from-blue to-blueby70 span1details"
                          data-teamname="Player B"
                          data-bettype="b"
                          data-market-type="m"
                          onClick={() =>
                            initializeBet("m", "Player B", "b", blueOdd)
                          }
                        >
                          <div className="h-12 w-12 opacity-70">
                            <svg
                              width="103"
                              height="120"
                              viewBox="0 0 103 120"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M13 107V13.9092H53.3636C60.4545 13.9092 66.4091 14.8637 71.2273 16.7728C76.0758 18.6819 79.7273 21.3789 82.1818 24.8637C84.6667 28.3486 85.9091 32.4546 85.9091 37.1819C85.9091 40.6061 85.1515 43.7274 83.6364 46.5455C82.1515 49.3637 80.0606 51.7274 77.3636 53.6365C74.6667 55.5152 71.5152 56.8183 67.9091 57.5455V58.4546C71.9091 58.6062 75.5455 59.6213 78.8182 61.5001C82.0909 63.3486 84.697 65.9092 86.6364 69.1819C88.5758 72.4243 89.5455 76.2425 89.5455 80.6365C89.5455 85.7274 88.2121 90.2577 85.5455 94.2274C82.9091 98.1971 79.1515 101.318 74.2727 103.591C69.3939 105.864 63.5758 107 56.8182 107H13ZM38.2727 86.8183H50.0909C54.3333 86.8183 57.5152 86.0304 59.6364 84.4546C61.7576 82.8486 62.8182 80.4849 62.8182 77.3637C62.8182 75.1819 62.3182 73.3334 61.3182 71.8183C60.3182 70.3031 58.8939 69.1516 57.0455 68.3637C55.2273 67.5758 53.0303 67.1819 50.4545 67.1819H38.2727V86.8183ZM38.2727 51.5455H48.6364C50.8485 51.5455 52.803 51.1971 54.5 50.5001C56.197 49.8031 57.5152 48.8031 58.4545 47.5001C59.4242 46.1668 59.9091 44.5455 59.9091 42.6365C59.9091 39.7577 58.8788 37.5607 56.8182 36.0455C54.7576 34.5001 52.1515 33.7274 49 33.7274H38.2727V51.5455Z"
                                fill="white"
                              ></path>
                              <path
                                d="M6.5 107V113.5H13H56.8182C64.2888 113.5 71.0886 112.245 77.0175 109.483C82.8313 106.775 87.5705 102.921 90.9506 97.8377C94.3781 92.7293 96.0455 86.9249 96.0455 80.6365C96.0455 75.2666 94.8519 70.26 92.222 65.8576C90.0515 62.1984 87.1984 59.1833 83.7058 56.8747C86.0091 54.7977 87.9117 52.3687 89.3744 49.5994C91.4249 45.7755 92.4091 41.5935 92.4091 37.1819C92.4091 31.2562 90.8298 25.803 87.485 21.1052C84.1524 16.3812 79.3711 12.9948 73.6148 10.7272C67.8115 8.42908 60.9893 7.40918 53.3636 7.40918H13H6.5V13.9092V107ZM48.6364 45.0455H44.7727V40.2274H49C51.0664 40.2274 52.2152 40.7183 52.9182 41.2455L52.9428 41.264L52.9677 41.2823C53.1725 41.4329 53.2221 41.527 53.2514 41.5895C53.2929 41.6781 53.4091 41.9752 53.4091 42.6365C53.4091 43.3871 53.2409 43.6178 53.1993 43.6749L53.1978 43.677L53.1898 43.6879L53.1819 43.6989C53.0487 43.8837 52.7681 44.1845 52.0305 44.4875C51.2605 44.8037 50.1717 45.0455 48.6364 45.0455ZM54.461 74.3278L54.4789 74.3356L54.4968 74.3432C55.3022 74.6865 55.67 75.0605 55.8932 75.3987C56.0611 75.6532 56.3182 76.1946 56.3182 77.3637C56.3182 78.7684 55.9595 79.0848 55.7472 79.2464C55.23 79.6231 53.6871 80.3183 50.0909 80.3183H44.7727V73.6819H50.4545C52.396 73.6819 53.6638 73.9824 54.461 74.3278Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>
                          <span className="absolute txt-left-bottom left-0.5 p-2p px-1 bg-blackby20 rounded-sm text-[10px] odd">
                            {blueOdd}
                          </span>
                          <div
                            className={
                              blueOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {blueOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              blueEqual21Win ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>
                      </div>

                      <div
                        className="flex flex-col gap-half"
                        style={{ cursor: "pointer" }}
                      >
                        {/*blueGreterThenOdd*/}
                        <div
                          id="greaterThan21B"
                          className="relative p-2 bg-gradient-to-t from-blue to-blueby70 border border-transparent rounded-tr-md span1details"
                          data-teamname="greaterThan21B"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet(
                              "f",
                              "greaterThan21B",
                              "b",
                              blueGreterThenOdd
                            )
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom  p-2p px-1 bg-blackby20 rounded-sm odd">
                            {blueGreterThenOdd}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="242"
                              height="121"
                              viewBox="0 0 242 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M81.1818 72.3635L13.5454 99.4544V76.5453L56.6363 61.6362L55.909 62.7271V60.1817L56.6363 61.2726L13.5454 46.3635V23.4544L81.1818 50.5453V72.3635Z"
                                fill="white"
                              ></path>
                              <path
                                d="M99.2118 108V89.8181L133.939 61.0908C136.242 59.1817 138.212 57.3938 139.848 55.7271C141.515 54.0302 142.788 52.2877 143.666 50.4999C144.575 48.712 145.03 46.7271 145.03 44.5453C145.03 42.1514 144.515 40.1059 143.484 38.409C142.484 36.712 141.091 35.409 139.303 34.4999C137.515 33.5605 135.454 33.0908 133.121 33.0908C130.788 33.0908 128.727 33.5605 126.939 34.4999C125.181 35.4393 123.818 36.818 122.848 38.6362C121.878 40.4544 121.394 42.6665 121.394 45.2726H97.3936C97.3936 38.7271 98.8633 33.0908 101.803 28.3635C104.742 23.6362 108.894 19.9999 114.257 17.4544C119.621 14.909 125.909 13.6362 133.121 13.6362C140.575 13.6362 147.03 14.8332 152.484 17.2271C157.969 19.5908 162.197 22.9241 165.166 27.2271C168.166 31.5302 169.666 36.5756 169.666 42.3635C169.666 45.9393 168.924 49.4999 167.439 53.0453C165.954 56.5605 163.288 60.4544 159.439 64.7271C155.591 68.9999 150.121 74.0908 143.03 79.9999L134.303 87.2726V87.8181H170.666V108H99.2118Z"
                                fill="white"
                              ></path>
                              <path
                                d="M228.878 14.909V108H203.605V38.1817H203.06L182.696 50.3635V28.909L205.605 14.909H228.878Z"
                                fill="white"
                              ></path>
                              <path
                                d="M83.5986 78.3975L87.6818 76.762V72.3635V50.5453V46.1468L83.5986 44.5113L15.9622 17.4204L7.04541 13.8489V23.4544V46.3635V50.9926L11.4201 52.5062L37.2825 61.4544L11.4201 70.4026L7.04541 71.9162V76.5453V99.4544V109.06L15.9622 105.488L83.5986 78.3975ZM92.7118 108V114.5H99.2118H170.666H177.166V108V87.8181V81.3181H170.666H151.516C156.723 76.7983 160.993 72.7137 164.269 69.0773C168.382 64.511 171.555 60.0046 173.427 55.5746L173.431 55.5654L173.434 55.5562C175.227 51.2758 176.166 46.8644 176.166 42.3635C176.166 35.3959 174.34 29.0266 170.508 23.524C166.755 18.0901 161.506 14.0405 155.076 11.2662C148.624 8.43835 141.247 7.13623 133.121 7.13623C125.148 7.13623 117.872 8.54423 111.47 11.5821C105.059 14.6248 99.9248 19.074 96.2828 24.9312C92.5974 30.8582 90.8936 37.7304 90.8936 45.2726V51.7726H97.3936H121.394H127.894V45.2726C127.894 43.4573 128.231 42.3551 128.583 41.6951C128.965 40.9803 129.411 40.5531 129.983 40.243C130.702 39.8701 131.69 39.5908 133.121 39.5908C134.565 39.5908 135.559 39.8756 136.279 40.2539L136.318 40.2742L136.357 40.2939C137.062 40.6524 137.525 41.0997 137.884 41.709L137.906 41.7458L137.928 41.7823C138.225 42.271 138.53 43.0951 138.53 44.5453C138.53 45.7949 138.277 46.757 137.872 47.5538L137.852 47.5931L137.833 47.6326C137.313 48.6905 136.483 49.8774 135.211 51.1725L135.21 51.1733C133.766 52.6442 131.97 54.2804 129.794 56.0838C129.793 56.0847 129.792 56.0857 129.791 56.0866L95.0686 84.8096L92.7118 86.7593V89.8181V108ZM235.378 14.909V8.40896H228.878H205.605H203.777L202.216 9.36263L179.307 23.3626L176.196 25.2635V28.909V50.3635V61.8262L186.033 55.9416L197.105 49.3181V108V114.5H203.605H228.878H235.378V108V14.909Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              blueGreterThenOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {blueGreterThenOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              blueGreaterThan21Win
                                ? "zero-value"
                                : "zero-value hides"
                            }
                            style={{
                              position: "unset",
                              transform: "unset"
                            }}
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*blueEqual*/}
                        <div
                          id="21yesB"
                          className="relative p-2 bg-gradient-to-t from-blue to-blueby70 border border-transparent span1details"
                          data-teamname="21yesB"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet("f", "21yesB", "b", blueEqual)
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom  p-2p px-1 bg-blackby20 rounded-sm odd">
                            {blueEqual}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="158"
                              height="121"
                              viewBox="0 0 158 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M15.182 108V89.8183L49.9092 61.091C52.2123 59.1819 54.182 57.3941 55.8183 55.7274C57.485 54.0304 58.7577 52.288 59.6365 50.5001C60.5456 48.7122 61.0001 46.7274 61.0001 44.5456C61.0001 42.1516 60.485 40.1062 59.4547 38.4092C58.4547 36.7122 57.0607 35.4092 55.2729 34.5001C53.485 33.5607 51.4244 33.091 49.091 33.091C46.7577 33.091 44.6971 33.5607 42.9092 34.5001C41.1516 35.4395 39.788 36.8183 38.8183 38.6365C37.8486 40.4547 37.3638 42.6668 37.3638 45.2728H13.3638C13.3638 38.7274 14.8335 33.091 17.7729 28.3637C20.7123 23.6365 24.8638 20.0001 30.2274 17.4547C35.591 14.9092 41.8789 13.6365 49.091 13.6365C56.5456 13.6365 63.0001 14.8334 68.4547 17.2274C73.9395 19.591 78.1668 22.9244 81.1365 27.2274C84.1365 31.5304 85.6365 36.5759 85.6365 42.3637C85.6365 45.9395 84.8941 49.5001 83.4092 53.0456C81.9244 56.5607 79.2577 60.4547 75.4092 64.7274C71.5607 69.0001 66.091 74.091 59.0001 80.0001L50.2729 87.2728V87.8183H86.6365V108H15.182Z"
                                fill="white"
                              ></path>
                              <path
                                d="M144.848 14.9092V108H119.576V38.1819H119.03L98.6665 50.3638V28.9092L121.576 14.9092H144.848Z"
                                fill="white"
                              ></path>
                              <path
                                d="M8.68195 108V114.5H15.182H86.6365H93.1365V108V87.8183V81.3183H86.6365H67.4862C72.6934 76.7986 76.9636 72.7139 80.2389 69.0775C84.3519 64.5112 87.5257 60.0048 89.3969 55.5749L89.4008 55.5657L89.4047 55.5565C91.1973 51.2761 92.1365 46.8647 92.1365 42.3637C92.1365 35.3956 90.31 29.0258 86.4776 23.5229C82.7243 18.0899 77.4757 14.0407 71.0469 11.2666C64.5944 8.43866 57.2175 7.13647 49.091 7.13647C41.1183 7.13647 33.8419 8.54448 27.4406 11.5824C21.0292 14.6251 15.8949 19.0743 12.2529 24.9315L17.7729 28.3637L12.2529 24.9315C8.5676 30.8584 6.86377 37.7306 6.86377 45.2728V51.7728H13.3638H37.3638H43.8638V45.2728C43.8638 43.4575 44.2016 42.3553 44.5536 41.6953C44.9348 40.9806 45.3812 40.5533 45.9535 40.2433C46.6718 39.8704 47.6606 39.591 49.091 39.591C50.5354 39.591 51.5295 39.8759 52.2495 40.2542L52.288 40.2744L52.3268 40.2941C53.0318 40.6526 53.4957 41.1 53.8547 41.7092L53.8764 41.746L53.8986 41.7826C54.1952 42.2712 54.5001 43.0954 54.5001 44.5456C54.5001 45.7951 54.2476 46.7572 53.8425 47.554L53.8225 47.5933L53.8031 47.6328C53.2831 48.6908 52.4529 49.8777 51.1809 51.1728L51.1802 51.1735C49.7356 52.6448 47.9387 54.2815 45.7625 56.0855C45.762 56.086 45.7615 56.0864 45.761 56.0868L11.0388 84.8098L8.68195 86.7595V89.8183V108ZM151.348 14.9092V8.4092H144.848H121.576H119.747L118.186 9.36287L95.2771 23.3629L92.1665 25.2638V28.9092V50.3638V61.8264L102.003 55.9418L113.076 49.3183V108V114.5H119.576H144.848H151.348V108V14.9092Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              blueEqualAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {blueEqualAmount}
                            </span>
                          </div>
                          <span
                            className={
                              blueEqual21Win ? "zero-value" : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>

                        {/*blueLessThenOdd*/}
                        <div
                          id="lessThan21B"
                          className="relative p-2 bg-gradient-to-t from-blue to-blueby70 border border-transparent span1details"
                          data-teamname="lessThan21B"
                          data-bettype="b"
                          data-market-type="f"
                          onClick={() =>
                            initializeBet(
                              "f",
                              "lessThan21B",
                              "b",
                              blueLessThenOdd
                            )
                          }
                        >
                          <span className="text-[10px] absolute txt-left-bottom  p-2p px-1 bg-blackby20 rounded-sm odd">
                            {blueLessThenOdd}
                          </span>
                          <div className="w-12 h-10 opacity-70">
                            <svg
                              width="242"
                              height="121"
                              viewBox="0 0 242 121"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-full h-full"
                            >
                              <path
                                d="M13.5454 72.3635V50.5453L81.1818 23.4544V46.3635L38.0909 61.2726L38.8181 60.1817V62.7271L38.0909 61.6362L81.1818 76.5453V99.4544L13.5454 72.3635Z"
                                fill="white"
                              ></path>
                              <path
                                d="M99.2118 108V89.8181L133.939 61.0908C136.242 59.1817 138.212 57.3938 139.848 55.7271C141.515 54.0302 142.788 52.2877 143.666 50.4999C144.575 48.712 145.03 46.7271 145.03 44.5453C145.03 42.1514 144.515 40.1059 143.484 38.409C142.484 36.712 141.091 35.409 139.303 34.4999C137.515 33.5605 135.454 33.0908 133.121 33.0908C130.788 33.0908 128.727 33.5605 126.939 34.4999C125.181 35.4393 123.818 36.818 122.848 38.6362C121.878 40.4544 121.394 42.6665 121.394 45.2726H97.3936C97.3936 38.7271 98.8633 33.0908 101.803 28.3635C104.742 23.6362 108.894 19.9999 114.257 17.4544C119.621 14.909 125.909 13.6362 133.121 13.6362C140.575 13.6362 147.03 14.8332 152.484 17.2271C157.969 19.5908 162.197 22.9241 165.166 27.2271C168.166 31.5302 169.666 36.5756 169.666 42.3635C169.666 45.9393 168.924 49.4999 167.439 53.0453C165.954 56.5605 163.288 60.4544 159.439 64.7271C155.591 68.9999 150.121 74.0908 143.03 79.9999L134.303 87.2726V87.8181H170.666V108H99.2118Z"
                                fill="white"
                              ></path>
                              <path
                                d="M228.878 14.909V108H203.605V38.1817H203.06L182.696 50.3635V28.909L205.605 14.909H228.878Z"
                                fill="white"
                              ></path>
                              <path
                                d="M7.04541 72.3635V76.762L11.1286 78.3975L78.7649 105.488L87.6818 109.06V99.4544V76.5453V71.9162L83.3071 70.4026L57.4446 61.4544L83.3071 52.5062L87.6818 50.9926V46.3635V23.4544V13.8489L78.7649 17.4204L11.1286 44.5113L7.04541 46.1468V50.5453V72.3635ZM92.7118 108V114.5H99.2118H170.666H177.166V108V87.8181V81.3181H170.666H151.516C156.723 76.7983 160.993 72.7137 164.269 69.0773C168.382 64.511 171.555 60.0046 173.427 55.5746L173.431 55.5654L173.434 55.5562C175.227 51.2758 176.166 46.8644 176.166 42.3635C176.166 35.3959 174.34 29.0266 170.508 23.524C166.755 18.0901 161.506 14.0405 155.076 11.2662C148.624 8.43835 141.247 7.13623 133.121 7.13623C125.148 7.13623 117.872 8.54423 111.47 11.5821C105.059 14.6248 99.9248 19.074 96.2828 24.9312C92.5974 30.8582 90.8936 37.7304 90.8936 45.2726V51.7726H97.3936H121.394H127.894V45.2726C127.894 43.4573 128.231 42.3551 128.583 41.6951C128.965 40.9803 129.411 40.5531 129.983 40.243C130.702 39.8701 131.69 39.5908 133.121 39.5908C134.565 39.5908 135.559 39.8756 136.279 40.2539L136.318 40.2742L136.357 40.2939C137.062 40.6524 137.525 41.0997 137.884 41.709L137.906 41.7458L137.928 41.7823C138.225 42.271 138.53 43.0951 138.53 44.5453C138.53 45.7949 138.277 46.757 137.872 47.5538L137.852 47.5931L137.833 47.6326C137.313 48.6905 136.483 49.8774 135.211 51.1725L135.21 51.1733C133.766 52.6442 131.97 54.2804 129.794 56.0838C129.793 56.0847 129.792 56.0857 129.791 56.0866L95.0686 84.8096L92.7118 86.7593V89.8181V108ZM235.378 14.909V8.40896H228.878H205.605H203.777L202.216 9.36263L179.307 23.3626L176.196 25.2635V28.909V50.3635V61.8262L186.033 55.9416L197.105 49.3181V108V114.5H203.605H228.878H235.378V108V14.909Z"
                                stroke="white"
                                stroke-opacity="0.4"
                                stroke-width="13"
                              ></path>
                            </svg>
                          </div>

                          <div
                            className={
                              blueLessThenOddAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span className="Rou-image-text">
                              {blueLessThenOddAmount}
                            </span>
                          </div>
                          <span
                            className={
                              blueLessThan21Win
                                ? "zero-value"
                                : "zero-value hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              className="zero-icon"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="grid grid-cols-4 gap-half "
                      style={{ display: "flex", cursor: "pointer" }}
                    >
                      {/*allABlack*/}
                      <div
                        id="ABlack"
                        className="relative p-2 bg-rgba-grey   flex items-center justify-center h-14 border border-transparent bg-gradient-to-t from-white/40 to-whiteby30 rounded-bl-md  span1details"
                        data-teamname="ABlack"
                        data-bettype="b"
                        data-market-type="f"
                        onClick={() =>
                          initializeBet("f", "ABlack", "b", allABlack)
                        }
                      >
                        <div className=" h-full  opacity-70 ">
                          <svg
                            width="262"
                            height="151"
                            viewBox="0 0 262 151"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full h-full"
                          >
                            <mask
                              id="path-1-outside-1_3662_1164"
                              maskUnits="userSpaceOnUse"
                              x="0.220215"
                              y="0.45459"
                              width="261"
                              height="151"
                              fill="black"
                            >
                              <rect
                                fill="white"
                                x="0.220215"
                                y="0.45459"
                                width="261"
                                height="151"
                              ></rect>
                              <path d="M36.2411 60H22.6048L37.9684 13.4546H55.2411L70.6048 60H56.9684L46.7866 26.2728H46.4229L36.2411 60ZM33.6957 41.6364H59.332V51.091H33.6957V41.6364Z"></path>
                              <path d="M75.7277 60V13.4546H88.3641V49.8182H107.182V60H75.7277Z"></path>
                              <path d="M112.93 60V13.4546H125.567V49.8182H144.385V60H112.93Z"></path>
                              <path d="M189.004 60H175.367L190.731 13.4546H208.004L223.367 60H209.731L199.549 26.2728H199.185L189.004 60ZM186.458 41.6364H212.095V51.091H186.458V41.6364Z"></path>
                              <path d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"></path>
                              <path d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"></path>
                              <path d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"></path>
                              <path d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"></path>
                              <path d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"></path>
                            </mask>
                            <path
                              d="M36.2411 60H22.6048L37.9684 13.4546H55.2411L70.6048 60H56.9684L46.7866 26.2728H46.4229L36.2411 60ZM33.6957 41.6364H59.332V51.091H33.6957V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M75.7277 60V13.4546H88.3641V49.8182H107.182V60H75.7277Z"
                              fill="white"
                            ></path>
                            <path
                              d="M112.93 60V13.4546H125.567V49.8182H144.385V60H112.93Z"
                              fill="white"
                            ></path>
                            <path
                              d="M189.004 60H175.367L190.731 13.4546H208.004L223.367 60H209.731L199.549 26.2728H199.185L189.004 60ZM186.458 41.6364H212.095V51.091H186.458V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"
                              fill="white"
                            ></path>
                            <path
                              d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"
                              fill="white"
                            ></path>
                            <path
                              d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"
                              fill="white"
                            ></path>
                            <path
                              d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"
                              fill="white"
                            ></path>
                            <path
                              d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"
                              fill="white"
                            ></path>
                            <path
                              d="M36.2411 60H22.6048L37.9684 13.4546H55.2411L70.6048 60H56.9684L46.7866 26.2728H46.4229L36.2411 60ZM33.6957 41.6364H59.332V51.091H33.6957V41.6364Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M75.7277 60V13.4546H88.3641V49.8182H107.182V60H75.7277Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M112.93 60V13.4546H125.567V49.8182H144.385V60H112.93Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M189.004 60H175.367L190.731 13.4546H208.004L223.367 60H209.731L199.549 26.2728H199.185L189.004 60ZM186.458 41.6364H212.095V51.091H186.458V41.6364Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                            <path
                              d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1164)"
                            ></path>
                          </svg>
                        </div>
                        <span className="text-[10px] absolute txt-left-bottom p-2p px-1 bg-blackby20 rounded-sm odd">
                          {allABlack}
                        </span>
                        <span className="absolute flex items-center justify-center gap-1 txt-top-left">
                          <svg
                            width="209"
                            height="211"
                            viewBox="0 0 209 211"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M159.999 78.8C151.699 78.8 143.999 80.9 137.199 84.5C146.899 75.6 152.999 62.9 152.999 48.7C152.999 21.9 131.299 0.100098 104.399 0.100098C77.5992 0.100098 55.7993 21.8 55.7993 48.7C55.7993 63 61.9992 75.7999 71.8992 84.7C64.9992 80.8999 57.0994 78.7 48.5994 78.7C21.8994 78.7 0.199219 100.4 0.199219 127.1C0.199219 153.8 21.8994 175.5 48.5994 175.5C72.7994 175.5 92.7992 157.7 96.3992 134.5C99.3992 157.8 92.2994 185.2 76.5994 210.9C85.7994 210.9 95.0993 210.9 104.299 210.9C113.499 210.9 122.799 210.9 131.999 210.9C116.299 185.2 109.199 157.9 112.199 134.5C115.799 157.7 135.799 175.5 159.999 175.5C186.699 175.5 208.399 153.8 208.399 127.1C208.399 100.4 186.699 78.8 159.999 78.8Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <span className="absolute txt-top-right">
                          <svg
                            width="209"
                            height="235"
                            viewBox="0 0 209 235"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M208.199 125.3C202.599 64.5 104.599 0.400024 104.599 0.400024C104.599 0.400024 12.6993 63.7 1.79932 120C1.49932 121.3 1.39922 122.6 1.19922 123.9C1.09922 124.3 1.09927 124.7 0.999268 125.1C0.799268 126.9 0.699219 128.7 0.699219 130.6C0.699219 159.3 23.9992 182.6 52.6992 182.6C71.2992 182.6 87.4992 172.8 96.6992 158.2C98.4992 181.8 90.8992 208.7 75.3992 234.1C85.1992 234.1 94.8992 234.1 104.699 234.1C114.499 234.1 124.199 234.1 133.999 234.1C118.399 208.7 110.899 181.7 112.699 158.2C121.899 172.9 138.099 182.6 156.699 182.6C185.399 182.6 208.699 159.3 208.699 130.6C208.499 128.9 208.399 127.1 208.199 125.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>

                        <div
                          className={
                            allABlackAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            className="rol-winner-icon"
                          />
                          <span className="Rou-image-text">
                            {allABlackAmount}
                          </span>
                        </div>
                        <span
                          className={
                            allBBlackWin ? "zero-value" : "zero-value hides"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            className="zero-icon"
                          />
                        </span>
                      </div>

                      {/*allARed*/}
                      <div
                        id="ARed"
                        className="relative p-2  bg-rgba-grey  flex items-center justify-center h-14 border border-transparent bg-gradient-to-t from-white/40 to-whiteby30 span1details"
                        data-teamname="ARed"
                        data-bettype="b"
                        data-market-type="f"
                        onClick={() => initializeBet("f", "ARed", "b", allARed)}
                      >
                        <div className=" h-full  opacity-70 ">
                          <svg
                            width="238"
                            height="150"
                            viewBox="0 0 238 150"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full h-full"
                          >
                            <path
                              d="M32.2409 60H18.6045L33.9681 13.4546H51.2409L66.6045 60H52.9681L42.7863 26.2728H42.4227L32.2409 60ZM29.6954 41.6364H55.3318V51.091H29.6954V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M71.7274 60V13.4546H84.3638V49.8182H103.182V60H71.7274Z"
                              fill="white"
                            ></path>
                            <path
                              d="M108.93 60V13.4546H121.566V49.8182H140.384V60H108.93Z"
                              fill="white"
                            ></path>
                            <path
                              d="M185.003 60H171.367L186.731 13.4546H204.003L219.367 60H205.731L195.549 26.2728H195.185L185.003 60ZM182.458 41.6364H208.094V51.091H182.458V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M63.3049 137V90.4546H83.3959C86.8504 90.4546 89.8731 91.0834 92.464 92.341C95.0549 93.5985 97.0701 95.4091 98.5095 97.7728C99.9489 100.136 100.669 102.97 100.669 106.273C100.669 109.606 99.9262 112.417 98.4413 114.705C96.9716 116.992 94.9034 118.72 92.2368 119.886C89.5852 121.053 86.4868 121.636 82.9413 121.636H70.9413V111.818H80.3959C81.8807 111.818 83.1459 111.636 84.1913 111.273C85.2519 110.894 86.0625 110.295 86.6231 109.477C87.1989 108.659 87.4868 107.591 87.4868 106.273C87.4868 104.939 87.1989 103.856 86.6231 103.023C86.0625 102.174 85.2519 101.553 84.1913 101.159C83.1459 100.75 81.8807 100.546 80.3959 100.546H75.9413V137H63.3049ZM90.5777 115.636L102.214 137H88.4868L77.1231 115.636H90.5777Z"
                              fill="white"
                            ></path>
                            <path
                              d="M106.695 137V90.4546H140.24V100.636H119.331V108.636H138.513V118.818H119.331V126.818H140.149V137H106.695Z"
                              fill="white"
                            ></path>
                            <path
                              d="M165.057 137H147.147V90.4546H164.875C169.663 90.4546 173.799 91.3864 177.284 93.25C180.784 95.0985 183.481 97.7652 185.375 101.25C187.284 104.72 188.238 108.879 188.238 113.727C188.238 118.576 187.291 122.742 185.397 126.227C183.504 129.697 180.822 132.364 177.352 134.227C173.882 136.076 169.784 137 165.057 137ZM159.784 126.273H164.602C166.905 126.273 168.867 125.902 170.488 125.159C172.125 124.417 173.367 123.136 174.216 121.318C175.079 119.5 175.511 116.97 175.511 113.727C175.511 110.485 175.072 107.955 174.193 106.136C173.329 104.318 172.057 103.038 170.375 102.296C168.708 101.553 166.663 101.182 164.238 101.182H159.784V126.273Z"
                              fill="white"
                            ></path>
                            <path
                              d="M32.2409 66.5H37.0683L38.4635 61.8786L39.7579 57.591H45.4511L46.7455 61.8786L48.1407 66.5H52.9681H65.2274H66.6045H71.7274H75.5949H102.43H103.182H108.93H109.682H140.384H146.884V60V49.8182V43.3182H140.384H128.066V13.4546V6.95459H121.566H108.93H102.43V13.4546V43.3182H90.8638V13.4546V6.95459H84.3638H71.7274H65.2274V13.4546V35.0908L57.4133 11.4172L55.9403 6.95459H51.2409H33.9681H29.2687L27.7957 11.4172L12.432 57.9627L9.61404 66.5H18.6045H32.2409ZM185.003 66.5H189.831L191.226 61.8786L192.52 57.591H198.214L199.508 61.8786L200.903 66.5H205.731H219.367H228.357L225.539 57.9627L210.176 11.4172L208.703 6.95459H204.003H186.731H182.031L180.558 11.4172L165.195 57.9627L162.377 66.5H171.367H185.003ZM56.8049 137V143.5H63.3049H75.9413H82.4413V139.476L82.7481 140.053L84.5819 143.5H88.4868H100.195H102.214H106.695H113.156H140.149H140.647H146.649H147.147H165.057C170.635 143.5 175.825 142.406 180.408 139.964L180.418 139.959L180.428 139.954C185.013 137.491 188.607 133.914 191.103 129.342L191.109 129.331C193.623 124.704 194.738 119.421 194.738 113.727C194.738 108.032 193.615 102.749 191.077 98.1297C188.576 93.5348 184.957 89.9557 180.335 87.5107C175.731 85.0519 170.502 83.9546 164.875 83.9546H147.147H146.74H140.647H140.24H106.695H100.195V89.7464C98.7446 88.455 97.1067 87.3692 95.3023 86.4934C91.6677 84.7292 87.6399 83.9546 83.3959 83.9546H63.3049H56.8049V90.4546V137ZM167.782 119.249C167.448 119.402 166.964 119.558 166.284 119.66V107.831C166.931 107.937 167.4 108.086 167.73 108.233L167.74 108.237L167.75 108.242L167.755 108.244C167.873 108.296 168.062 108.38 168.322 108.925L168.331 108.945L168.341 108.965C168.611 109.525 169.011 110.937 169.011 113.727C169.011 116.528 168.617 117.956 168.344 118.529L168.335 118.549L168.325 118.569C168.065 119.127 167.88 119.207 167.813 119.236C167.809 119.237 167.806 119.239 167.803 119.24L167.792 119.245L167.782 119.249Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="13"
                            ></path>
                          </svg>
                        </div>
                        <span className="text-[10px] absolute txt-left-bottom p-2p px-1 bg-blackby20 rounded-sm odd">
                          {allARed}
                        </span>
                        <span className="absolute flex items-center justify-center gap-1 txt-top-left">
                          <svg
                            width="198"
                            height="260"
                            viewBox="0 0 198 260"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              d="M151.5 77.6C130.7 50.3 114.6 24.1 102.2 0.699951C89.4002 22.4 73.4002 46.5 53.7002 71.4C40.8002 87.7 23.3002 108.1 0.700195 130.3C17.5002 146.8 35.6002 166.3 53.7002 189.2C73.4002 214.1 89.4002 238.2 102.2 259.9C114.6 236.6 130.7 210.3 151.5 183C167 162.7 182.5 145.2 197.1 130.2C182.5 115.4 167 97.9 151.5 77.6Z"
                              fill="#DD181F"
                            ></path>
                          </svg>
                        </span>
                        <span className="absolute txt-top-right">
                          <svg
                            width="220"
                            height="194"
                            viewBox="0 0 220 194"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M220 55.3C220 24.9 195.4 0.299988 165 0.299988C134.6 0.299988 110 24.9 110 55.3C110 24.9 85.4 0.299988 55 0.299988C24.6 0.299988 0 24.9 0 55.3C0 57.3 0.100049 59.2 0.300049 61.1C0.300049 61.5 0.4 62 0.5 62.4C0.7 63.8 0.900098 65.1 1.1001 66.5C12.7001 126.1 109.9 193.1 109.9 193.1C109.9 193.1 213.7 125.3 219.6 60.9C219.9 59.1 220 57.2 220 55.3Z"
                              fill="#DD181F"
                            ></path>
                          </svg>
                        </span>

                        <div
                          className={
                            allARedAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            className="rol-winner-icon"
                          />
                          <span className="Rou-image-text">
                            {allARedAmount}
                          </span>
                        </div>
                        <span
                          className={
                            allARedWin ? "zero-value" : "zero-value hides"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            className="zero-icon"
                          />
                        </span>
                      </div>

                      {/*allBBlack*/}
                      <div
                        id="BBlack"
                        className="relative p-2  bg-rgba-grey  flex items-center justify-center h-14 border border-transparent bg-gradient-to-t from-white/40 to-whiteby30 span1details"
                        data-teamname="BBlack"
                        data-bettype="b"
                        data-market-type="f"
                        onClick={() =>
                          initializeBet("f", "BBlack", "b", allBBlack)
                        }
                      >
                        <div className=" h-full  opacity-70 ">
                          <svg
                            width="262"
                            height="151"
                            viewBox="0 0 262 151"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full h-full"
                          >
                            <mask
                              id="path-1-outside-1_3662_1162"
                              maskUnits="userSpaceOnUse"
                              x="0.220215"
                              y="0.45459"
                              width="261"
                              height="151"
                              fill="black"
                            >
                              <rect
                                fill="white"
                                x="0.220215"
                                y="0.45459"
                                width="261"
                                height="151"
                              ></rect>
                              <path d="M40.3349 60H26.6985L42.0621 13.4546H59.3349L74.6985 60H61.0621L50.8803 26.2728H50.5167L40.3349 60ZM37.7894 41.6364H63.4258V51.091H37.7894V41.6364Z"></path>
                              <path d="M79.8215 60V13.4546H92.4578V49.8182H111.276V60H79.8215Z"></path>
                              <path d="M117.024 60V13.4546H129.66V49.8182H148.479V60H117.024Z"></path>
                              <path d="M181.006 60V13.4546H201.188C204.734 13.4546 207.711 13.9319 210.12 14.8864C212.544 15.841 214.37 17.1894 215.597 18.9319C216.84 20.6743 217.461 22.7273 217.461 25.091C217.461 26.8031 217.082 28.3637 216.325 29.7728C215.582 31.1819 214.537 32.3637 213.188 33.3182C211.84 34.2576 210.264 34.9091 208.461 35.2728V35.7273C210.461 35.8031 212.279 36.3107 213.916 37.25C215.552 38.1743 216.855 39.4546 217.825 41.091C218.794 42.7122 219.279 44.6213 219.279 46.8182C219.279 49.3637 218.613 51.6288 217.279 53.6137C215.961 55.5985 214.082 57.1591 211.643 58.2955C209.203 59.4319 206.294 60 202.916 60H181.006ZM193.643 49.9091H199.552C201.673 49.9091 203.264 49.5152 204.325 48.7273C205.385 47.9243 205.916 46.7425 205.916 45.1819C205.916 44.091 205.666 43.1667 205.166 42.4091C204.666 41.6516 203.953 41.0758 203.029 40.6819C202.12 40.2879 201.022 40.091 199.734 40.091H193.643V49.9091ZM193.643 32.2728H198.825C199.931 32.2728 200.908 32.0985 201.756 31.75C202.605 31.4016 203.264 30.9016 203.734 30.25C204.219 29.5834 204.461 28.7728 204.461 27.8182C204.461 26.3788 203.946 25.2803 202.916 24.5228C201.885 23.75 200.582 23.3637 199.006 23.3637H193.643V32.2728Z"></path>
                              <path d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"></path>
                              <path d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"></path>
                              <path d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"></path>
                              <path d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"></path>
                              <path d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"></path>
                            </mask>
                            <path
                              d="M40.3349 60H26.6985L42.0621 13.4546H59.3349L74.6985 60H61.0621L50.8803 26.2728H50.5167L40.3349 60ZM37.7894 41.6364H63.4258V51.091H37.7894V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M79.8215 60V13.4546H92.4578V49.8182H111.276V60H79.8215Z"
                              fill="white"
                            ></path>
                            <path
                              d="M117.024 60V13.4546H129.66V49.8182H148.479V60H117.024Z"
                              fill="white"
                            ></path>
                            <path
                              d="M181.006 60V13.4546H201.188C204.734 13.4546 207.711 13.9319 210.12 14.8864C212.544 15.841 214.37 17.1894 215.597 18.9319C216.84 20.6743 217.461 22.7273 217.461 25.091C217.461 26.8031 217.082 28.3637 216.325 29.7728C215.582 31.1819 214.537 32.3637 213.188 33.3182C211.84 34.2576 210.264 34.9091 208.461 35.2728V35.7273C210.461 35.8031 212.279 36.3107 213.916 37.25C215.552 38.1743 216.855 39.4546 217.825 41.091C218.794 42.7122 219.279 44.6213 219.279 46.8182C219.279 49.3637 218.613 51.6288 217.279 53.6137C215.961 55.5985 214.082 57.1591 211.643 58.2955C209.203 59.4319 206.294 60 202.916 60H181.006ZM193.643 49.9091H199.552C201.673 49.9091 203.264 49.5152 204.325 48.7273C205.385 47.9243 205.916 46.7425 205.916 45.1819C205.916 44.091 205.666 43.1667 205.166 42.4091C204.666 41.6516 203.953 41.0758 203.029 40.6819C202.12 40.2879 201.022 40.091 199.734 40.091H193.643V49.9091ZM193.643 32.2728H198.825C199.931 32.2728 200.908 32.0985 201.756 31.75C202.605 31.4016 203.264 30.9016 203.734 30.25C204.219 29.5834 204.461 28.7728 204.461 27.8182C204.461 26.3788 203.946 25.2803 202.916 24.5228C201.885 23.75 200.582 23.3637 199.006 23.3637H193.643V32.2728Z"
                              fill="white"
                            ></path>
                            <path
                              d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"
                              fill="white"
                            ></path>
                            <path
                              d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"
                              fill="white"
                            ></path>
                            <path
                              d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"
                              fill="white"
                            ></path>
                            <path
                              d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"
                              fill="white"
                            ></path>
                            <path
                              d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"
                              fill="white"
                            ></path>
                            <path
                              d="M40.3349 60H26.6985L42.0621 13.4546H59.3349L74.6985 60H61.0621L50.8803 26.2728H50.5167L40.3349 60ZM37.7894 41.6364H63.4258V51.091H37.7894V41.6364Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M79.8215 60V13.4546H92.4578V49.8182H111.276V60H79.8215Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M117.024 60V13.4546H129.66V49.8182H148.479V60H117.024Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M181.006 60V13.4546H201.188C204.734 13.4546 207.711 13.9319 210.12 14.8864C212.544 15.841 214.37 17.1894 215.597 18.9319C216.84 20.6743 217.461 22.7273 217.461 25.091C217.461 26.8031 217.082 28.3637 216.325 29.7728C215.582 31.1819 214.537 32.3637 213.188 33.3182C211.84 34.2576 210.264 34.9091 208.461 35.2728V35.7273C210.461 35.8031 212.279 36.3107 213.916 37.25C215.552 38.1743 216.855 39.4546 217.825 41.091C218.794 42.7122 219.279 44.6213 219.279 46.8182C219.279 49.3637 218.613 51.6288 217.279 53.6137C215.961 55.5985 214.082 57.1591 211.643 58.2955C209.203 59.4319 206.294 60 202.916 60H181.006ZM193.643 49.9091H199.552C201.673 49.9091 203.264 49.5152 204.325 48.7273C205.385 47.9243 205.916 46.7425 205.916 45.1819C205.916 44.091 205.666 43.1667 205.166 42.4091C204.666 41.6516 203.953 41.0758 203.029 40.6819C202.12 40.2879 201.022 40.091 199.734 40.091H193.643V49.9091ZM193.643 32.2728H198.825C199.931 32.2728 200.908 32.0985 201.756 31.75C202.605 31.4016 203.264 30.9016 203.734 30.25C204.219 29.5834 204.461 28.7728 204.461 27.8182C204.461 26.3788 203.946 25.2803 202.916 24.5228C201.885 23.75 200.582 23.3637 199.006 23.3637H193.643V32.2728Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M13.2202 137V90.4546H33.402C36.9475 90.4546 39.9248 90.9319 42.3339 91.8864C44.7581 92.841 46.5839 94.1894 47.8111 95.9319C49.0536 97.6743 49.6748 99.7273 49.6748 102.091C49.6748 103.803 49.296 105.364 48.5384 106.773C47.796 108.182 46.7505 109.364 45.402 110.318C44.0535 111.258 42.4778 111.909 40.6748 112.273V112.727C42.6748 112.803 44.4929 113.311 46.1293 114.25C47.7657 115.174 49.0687 116.455 50.0384 118.091C51.0081 119.712 51.4929 121.621 51.4929 123.818C51.4929 126.364 50.8263 128.629 49.4929 130.614C48.1748 132.599 46.296 134.159 43.8566 135.296C41.4172 136.432 38.5081 137 35.1293 137H13.2202ZM25.8566 126.909H31.7657C33.8869 126.909 35.4778 126.515 36.5384 125.727C37.599 124.924 38.1293 123.742 38.1293 122.182C38.1293 121.091 37.8793 120.167 37.3793 119.409C36.8793 118.652 36.1672 118.076 35.2429 117.682C34.3339 117.288 33.2354 117.091 31.9475 117.091H25.8566V126.909ZM25.8566 109.273H31.0384C32.1445 109.273 33.1217 109.099 33.9702 108.75C34.8187 108.402 35.4778 107.902 35.9475 107.25C36.4323 106.583 36.6748 105.773 36.6748 104.818C36.6748 103.379 36.1596 102.28 35.1293 101.523C34.099 100.75 32.796 100.364 31.2202 100.364H25.8566V109.273Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M56.6102 137V90.4546H69.2466V126.818H88.0648V137H56.6102Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M105.904 137H92.2673L107.631 90.4546H124.904L140.267 137H126.631L116.449 103.273H116.085L105.904 137ZM103.358 118.636H128.995V128.091H103.358V118.636Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M186.657 107.909H173.839C173.748 106.849 173.506 105.886 173.112 105.023C172.733 104.159 172.203 103.417 171.521 102.796C170.854 102.159 170.044 101.674 169.089 101.341C168.135 100.992 167.051 100.818 165.839 100.818C163.718 100.818 161.922 101.333 160.453 102.364C158.998 103.394 157.892 104.871 157.135 106.796C156.392 108.72 156.021 111.03 156.021 113.727C156.021 116.576 156.4 118.962 157.157 120.886C157.93 122.796 159.044 124.235 160.498 125.205C161.953 126.159 163.703 126.636 165.748 126.636C166.915 126.636 167.96 126.492 168.885 126.205C169.809 125.902 170.612 125.47 171.294 124.909C171.975 124.349 172.528 123.674 172.953 122.886C173.392 122.083 173.688 121.182 173.839 120.182L186.657 120.273C186.506 122.242 185.953 124.25 184.998 126.296C184.044 128.326 182.688 130.205 180.93 131.932C179.188 133.644 177.028 135.023 174.453 136.068C171.877 137.114 168.885 137.636 165.475 137.636C161.203 137.636 157.369 136.72 153.975 134.886C150.597 133.053 147.922 130.356 145.953 126.796C143.998 123.235 143.021 118.879 143.021 113.727C143.021 108.545 144.021 104.182 146.021 100.636C148.021 97.0758 150.718 94.3864 154.112 92.5682C157.506 90.7349 161.294 89.8182 165.475 89.8182C168.415 89.8182 171.119 90.2197 173.589 91.0228C176.059 91.8258 178.225 93 180.089 94.5455C181.953 96.0758 183.453 97.9622 184.589 100.205C185.725 102.447 186.415 105.015 186.657 107.909Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                            <path
                              d="M193.03 137V90.4546H205.667V109.273H206.303L220.303 90.4546H235.03L219.303 111.182L235.394 137H220.303L209.848 119.546L205.667 125V137H193.03Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1162)"
                            ></path>
                          </svg>
                        </div>
                        <span className="text-[10px] absolute txt-left-bottom p-2p px-1 bg-blackby20 rounded-sm odd">
                          {allBBlack}
                        </span>
                        <span className="absolute flex items-center justify-center gap-1 txt-top-left">
                          <svg
                            width="209"
                            height="211"
                            viewBox="0 0 209 211"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M159.999 78.8C151.699 78.8 143.999 80.9 137.199 84.5C146.899 75.6 152.999 62.9 152.999 48.7C152.999 21.9 131.299 0.100098 104.399 0.100098C77.5992 0.100098 55.7993 21.8 55.7993 48.7C55.7993 63 61.9992 75.7999 71.8992 84.7C64.9992 80.8999 57.0994 78.7 48.5994 78.7C21.8994 78.7 0.199219 100.4 0.199219 127.1C0.199219 153.8 21.8994 175.5 48.5994 175.5C72.7994 175.5 92.7992 157.7 96.3992 134.5C99.3992 157.8 92.2994 185.2 76.5994 210.9C85.7994 210.9 95.0993 210.9 104.299 210.9C113.499 210.9 122.799 210.9 131.999 210.9C116.299 185.2 109.199 157.9 112.199 134.5C115.799 157.7 135.799 175.5 159.999 175.5C186.699 175.5 208.399 153.8 208.399 127.1C208.399 100.4 186.699 78.8 159.999 78.8Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <span className="absolute txt-top-right">
                          <svg
                            width="209"
                            height="235"
                            viewBox="0 0 209 235"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M208.199 125.3C202.599 64.5 104.599 0.400024 104.599 0.400024C104.599 0.400024 12.6993 63.7 1.79932 120C1.49932 121.3 1.39922 122.6 1.19922 123.9C1.09922 124.3 1.09927 124.7 0.999268 125.1C0.799268 126.9 0.699219 128.7 0.699219 130.6C0.699219 159.3 23.9992 182.6 52.6992 182.6C71.2992 182.6 87.4992 172.8 96.6992 158.2C98.4992 181.8 90.8992 208.7 75.3992 234.1C85.1992 234.1 94.8992 234.1 104.699 234.1C114.499 234.1 124.199 234.1 133.999 234.1C118.399 208.7 110.899 181.7 112.699 158.2C121.899 172.9 138.099 182.6 156.699 182.6C185.399 182.6 208.699 159.3 208.699 130.6C208.499 128.9 208.399 127.1 208.199 125.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>

                        <div
                          className={
                            allBBlackAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            className="rol-winner-icon"
                          />
                          <span className="Rou-image-text">
                            {allBBlackAmount}
                          </span>
                        </div>
                        <span
                          className={
                            allBBlackWin ? "zero-value" : "zero-value hides"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            className="zero-icon"
                          />
                        </span>
                      </div>

                      {/*allBRed*/}
                      <div
                        id="BRed"
                        className="relative p-2  bg-rgba-grey  flex items-center justify-center h-14 border border-transparent bg-gradient-to-t from-white/40 to-whiteby30 rounded-br-md span1details"
                        data-teamname="BRed"
                        data-bettype="b"
                        data-market-type="f"
                        onClick={() => initializeBet("f", "BRed", "b", allBRed)}
                      >
                        <div className=" h-full  opacity-70 ">
                          <svg
                            width="225"
                            height="150"
                            viewBox="0 0 225 150"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-full h-full"
                          >
                            <mask
                              id="path-1-outside-1_3662_1169"
                              maskUnits="userSpaceOnUse"
                              x="0.698242"
                              y="0.45459"
                              width="224"
                              height="150"
                              fill="black"
                            >
                              <rect
                                fill="white"
                                x="0.698242"
                                y="0.45459"
                                width="224"
                                height="150"
                              ></rect>
                              <path d="M32.3346 60H18.6982L34.0619 13.4546H51.3346L66.6982 60H53.0619L42.8801 26.2728H42.5164L32.3346 60ZM29.7892 41.6364H55.4255V51.091H29.7892V41.6364Z"></path>
                              <path d="M71.8212 60V13.4546H84.4576V49.8182H103.276V60H71.8212Z"></path>
                              <path d="M109.024 60V13.4546H121.66V49.8182H140.478V60H109.024Z"></path>
                              <path d="M173.006 60V13.4546H193.188C196.733 13.4546 199.711 13.9319 202.12 14.8864C204.544 15.841 206.37 17.1894 207.597 18.9319C208.84 20.6743 209.461 22.7273 209.461 25.091C209.461 26.8031 209.082 28.3637 208.324 29.7728C207.582 31.1819 206.537 32.3637 205.188 33.3182C203.84 34.2576 202.264 34.9091 200.461 35.2728V35.7273C202.461 35.8031 204.279 36.3107 205.915 37.25C207.552 38.1743 208.855 39.4546 209.824 41.091C210.794 42.7122 211.279 44.6213 211.279 46.8182C211.279 49.3637 210.612 51.6288 209.279 53.6137C207.961 55.5985 206.082 57.1591 203.643 58.2955C201.203 59.4319 198.294 60 194.915 60H173.006ZM185.643 49.9091H191.552C193.673 49.9091 195.264 49.5152 196.324 48.7273C197.385 47.9243 197.915 46.7425 197.915 45.1819C197.915 44.091 197.665 43.1667 197.165 42.4091C196.665 41.6516 195.953 41.0758 195.029 40.6819C194.12 40.2879 193.021 40.091 191.733 40.091H185.643V49.9091ZM185.643 32.2728H190.824C191.93 32.2728 192.908 32.0985 193.756 31.75C194.605 31.4016 195.264 30.9016 195.733 30.25C196.218 29.5834 196.461 28.7728 196.461 27.8182C196.461 26.3788 195.946 25.2803 194.915 24.5228C193.885 23.75 192.582 23.3637 191.006 23.3637H185.643V32.2728Z"></path>
                              <path d="M59.3049 137V90.4546H79.3959C82.8504 90.4546 85.8731 91.0834 88.464 92.341C91.0549 93.5985 93.0701 95.4091 94.5095 97.7728C95.9489 100.136 96.6686 102.97 96.6686 106.273C96.6686 109.606 95.9262 112.417 94.4413 114.705C92.9716 116.992 90.9034 118.72 88.2368 119.886C85.5852 121.053 82.4868 121.636 78.9413 121.636H66.9413V111.818H76.3959C77.8807 111.818 79.1459 111.636 80.1913 111.273C81.2519 110.894 82.0625 110.295 82.6231 109.477C83.1989 108.659 83.4868 107.591 83.4868 106.273C83.4868 104.939 83.1989 103.856 82.6231 103.023C82.0625 102.174 81.2519 101.553 80.1913 101.159C79.1459 100.75 77.8807 100.546 76.3959 100.546H71.9413V137H59.3049ZM86.5777 115.636L98.214 137H84.4868L73.1231 115.636H86.5777Z"></path>
                              <path d="M102.695 137V90.4546H136.24V100.636H115.331V108.636H134.513V118.818H115.331V126.818H136.149V137H102.695Z"></path>
                              <path d="M161.057 137H143.147V90.4546H160.875C165.663 90.4546 169.799 91.3864 173.284 93.25C176.784 95.0985 179.481 97.7652 181.375 101.25C183.284 104.72 184.238 108.879 184.238 113.727C184.238 118.576 183.291 122.742 181.397 126.227C179.504 129.697 176.822 132.364 173.352 134.227C169.882 136.076 165.784 137 161.057 137ZM155.784 126.273H160.602C162.905 126.273 164.867 125.902 166.488 125.159C168.125 124.417 169.367 123.136 170.216 121.318C171.079 119.5 171.511 116.97 171.511 113.727C171.511 110.485 171.072 107.955 170.193 106.136C169.329 104.318 168.057 103.038 166.375 102.296C164.708 101.553 162.663 101.182 160.238 101.182H155.784V126.273Z"></path>
                            </mask>
                            <path
                              d="M32.3346 60H18.6982L34.0619 13.4546H51.3346L66.6982 60H53.0619L42.8801 26.2728H42.5164L32.3346 60ZM29.7892 41.6364H55.4255V51.091H29.7892V41.6364Z"
                              fill="white"
                            ></path>
                            <path
                              d="M71.8212 60V13.4546H84.4576V49.8182H103.276V60H71.8212Z"
                              fill="white"
                            ></path>
                            <path
                              d="M109.024 60V13.4546H121.66V49.8182H140.478V60H109.024Z"
                              fill="white"
                            ></path>
                            <path
                              d="M173.006 60V13.4546H193.188C196.733 13.4546 199.711 13.9319 202.12 14.8864C204.544 15.841 206.37 17.1894 207.597 18.9319C208.84 20.6743 209.461 22.7273 209.461 25.091C209.461 26.8031 209.082 28.3637 208.324 29.7728C207.582 31.1819 206.537 32.3637 205.188 33.3182C203.84 34.2576 202.264 34.9091 200.461 35.2728V35.7273C202.461 35.8031 204.279 36.3107 205.915 37.25C207.552 38.1743 208.855 39.4546 209.824 41.091C210.794 42.7122 211.279 44.6213 211.279 46.8182C211.279 49.3637 210.612 51.6288 209.279 53.6137C207.961 55.5985 206.082 57.1591 203.643 58.2955C201.203 59.4319 198.294 60 194.915 60H173.006ZM185.643 49.9091H191.552C193.673 49.9091 195.264 49.5152 196.324 48.7273C197.385 47.9243 197.915 46.7425 197.915 45.1819C197.915 44.091 197.665 43.1667 197.165 42.4091C196.665 41.6516 195.953 41.0758 195.029 40.6819C194.12 40.2879 193.021 40.091 191.733 40.091H185.643V49.9091ZM185.643 32.2728H190.824C191.93 32.2728 192.908 32.0985 193.756 31.75C194.605 31.4016 195.264 30.9016 195.733 30.25C196.218 29.5834 196.461 28.7728 196.461 27.8182C196.461 26.3788 195.946 25.2803 194.915 24.5228C193.885 23.75 192.582 23.3637 191.006 23.3637H185.643V32.2728Z"
                              fill="white"
                            ></path>
                            <path
                              d="M59.3049 137V90.4546H79.3959C82.8504 90.4546 85.8731 91.0834 88.464 92.341C91.0549 93.5985 93.0701 95.4091 94.5095 97.7728C95.9489 100.136 96.6686 102.97 96.6686 106.273C96.6686 109.606 95.9262 112.417 94.4413 114.705C92.9716 116.992 90.9034 118.72 88.2368 119.886C85.5852 121.053 82.4868 121.636 78.9413 121.636H66.9413V111.818H76.3959C77.8807 111.818 79.1459 111.636 80.1913 111.273C81.2519 110.894 82.0625 110.295 82.6231 109.477C83.1989 108.659 83.4868 107.591 83.4868 106.273C83.4868 104.939 83.1989 103.856 82.6231 103.023C82.0625 102.174 81.2519 101.553 80.1913 101.159C79.1459 100.75 77.8807 100.546 76.3959 100.546H71.9413V137H59.3049ZM86.5777 115.636L98.214 137H84.4868L73.1231 115.636H86.5777Z"
                              fill="white"
                            ></path>
                            <path
                              d="M102.695 137V90.4546H136.24V100.636H115.331V108.636H134.513V118.818H115.331V126.818H136.149V137H102.695Z"
                              fill="white"
                            ></path>
                            <path
                              d="M161.057 137H143.147V90.4546H160.875C165.663 90.4546 169.799 91.3864 173.284 93.25C176.784 95.0985 179.481 97.7652 181.375 101.25C183.284 104.72 184.238 108.879 184.238 113.727C184.238 118.576 183.291 122.742 181.397 126.227C179.504 129.697 176.822 132.364 173.352 134.227C169.882 136.076 165.784 137 161.057 137ZM155.784 126.273H160.602C162.905 126.273 164.867 125.902 166.488 125.159C168.125 124.417 169.367 123.136 170.216 121.318C171.079 119.5 171.511 116.97 171.511 113.727C171.511 110.485 171.072 107.955 170.193 106.136C169.329 104.318 168.057 103.038 166.375 102.296C164.708 101.553 162.663 101.182 160.238 101.182H155.784V126.273Z"
                              fill="white"
                            ></path>
                            <path
                              d="M32.3346 60H18.6982L34.0619 13.4546H51.3346L66.6982 60H53.0619L42.8801 26.2728H42.5164L32.3346 60ZM29.7892 41.6364H55.4255V51.091H29.7892V41.6364Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M71.8212 60V13.4546H84.4576V49.8182H103.276V60H71.8212Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M109.024 60V13.4546H121.66V49.8182H140.478V60H109.024Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M173.006 60V13.4546H193.188C196.733 13.4546 199.711 13.9319 202.12 14.8864C204.544 15.841 206.37 17.1894 207.597 18.9319C208.84 20.6743 209.461 22.7273 209.461 25.091C209.461 26.8031 209.082 28.3637 208.324 29.7728C207.582 31.1819 206.537 32.3637 205.188 33.3182C203.84 34.2576 202.264 34.9091 200.461 35.2728V35.7273C202.461 35.8031 204.279 36.3107 205.915 37.25C207.552 38.1743 208.855 39.4546 209.824 41.091C210.794 42.7122 211.279 44.6213 211.279 46.8182C211.279 49.3637 210.612 51.6288 209.279 53.6137C207.961 55.5985 206.082 57.1591 203.643 58.2955C201.203 59.4319 198.294 60 194.915 60H173.006ZM185.643 49.9091H191.552C193.673 49.9091 195.264 49.5152 196.324 48.7273C197.385 47.9243 197.915 46.7425 197.915 45.1819C197.915 44.091 197.665 43.1667 197.165 42.4091C196.665 41.6516 195.953 41.0758 195.029 40.6819C194.12 40.2879 193.021 40.091 191.733 40.091H185.643V49.9091ZM185.643 32.2728H190.824C191.93 32.2728 192.908 32.0985 193.756 31.75C194.605 31.4016 195.264 30.9016 195.733 30.25C196.218 29.5834 196.461 28.7728 196.461 27.8182C196.461 26.3788 195.946 25.2803 194.915 24.5228C193.885 23.75 192.582 23.3637 191.006 23.3637H185.643V32.2728Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M59.3049 137V90.4546H79.3959C82.8504 90.4546 85.8731 91.0834 88.464 92.341C91.0549 93.5985 93.0701 95.4091 94.5095 97.7728C95.9489 100.136 96.6686 102.97 96.6686 106.273C96.6686 109.606 95.9262 112.417 94.4413 114.705C92.9716 116.992 90.9034 118.72 88.2368 119.886C85.5852 121.053 82.4868 121.636 78.9413 121.636H66.9413V111.818H76.3959C77.8807 111.818 79.1459 111.636 80.1913 111.273C81.2519 110.894 82.0625 110.295 82.6231 109.477C83.1989 108.659 83.4868 107.591 83.4868 106.273C83.4868 104.939 83.1989 103.856 82.6231 103.023C82.0625 102.174 81.2519 101.553 80.1913 101.159C79.1459 100.75 77.8807 100.546 76.3959 100.546H71.9413V137H59.3049ZM86.5777 115.636L98.214 137H84.4868L73.1231 115.636H86.5777Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M102.695 137V90.4546H136.24V100.636H115.331V108.636H134.513V118.818H115.331V126.818H136.149V137H102.695Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                            <path
                              d="M161.057 137H143.147V90.4546H160.875C165.663 90.4546 169.799 91.3864 173.284 93.25C176.784 95.0985 179.481 97.7652 181.375 101.25C183.284 104.72 184.238 108.879 184.238 113.727C184.238 118.576 183.291 122.742 181.397 126.227C179.504 129.697 176.822 132.364 173.352 134.227C169.882 136.076 165.784 137 161.057 137ZM155.784 126.273H160.602C162.905 126.273 164.867 125.902 166.488 125.159C168.125 124.417 169.367 123.136 170.216 121.318C171.079 119.5 171.511 116.97 171.511 113.727C171.511 110.485 171.072 107.955 170.193 106.136C169.329 104.318 168.057 103.038 166.375 102.296C164.708 101.553 162.663 101.182 160.238 101.182H155.784V126.273Z"
                              stroke="white"
                              stroke-opacity="0.4"
                              stroke-width="26"
                              mask="url(#path-1-outside-1_3662_1169)"
                            ></path>
                          </svg>
                        </div>
                        <span className="text-[10px] absolute txt-left-bottom p-2p px-1 bg-blackby20 rounded-sm odd">
                          {allBRed}
                        </span>
                        <span className="absolute flex items-center justify-center gap-1 txt-top-left">
                          <svg
                            width="198"
                            height="260"
                            viewBox="0 0 198 260"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              d="M151.5 77.6C130.7 50.3 114.6 24.1 102.2 0.699951C89.4002 22.4 73.4002 46.5 53.7002 71.4C40.8002 87.7 23.3002 108.1 0.700195 130.3C17.5002 146.8 35.6002 166.3 53.7002 189.2C73.4002 214.1 89.4002 238.2 102.2 259.9C114.6 236.6 130.7 210.3 151.5 183C167 162.7 182.5 145.2 197.1 130.2C182.5 115.4 167 97.9 151.5 77.6Z"
                              fill="#DD181F"
                            ></path>
                          </svg>
                        </span>
                        <span className="absolute txt-top-right">
                          <svg
                            width="220"
                            height="194"
                            viewBox="0 0 220 194"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                          >
                            <path
                              id="Vector"
                              d="M220 55.3C220 24.9 195.4 0.299988 165 0.299988C134.6 0.299988 110 24.9 110 55.3C110 24.9 85.4 0.299988 55 0.299988C24.6 0.299988 0 24.9 0 55.3C0 57.3 0.100049 59.2 0.300049 61.1C0.300049 61.5 0.4 62 0.5 62.4C0.7 63.8 0.900098 65.1 1.1001 66.5C12.7001 126.1 109.9 193.1 109.9 193.1C109.9 193.1 213.7 125.3 219.6 60.9C219.9 59.1 220 57.2 220 55.3Z"
                              fill="#DD181F"
                            ></path>
                          </svg>
                        </span>

                        <div
                          className={
                            allBRedAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            className="rol-winner-icon"
                          />
                          <span className="Rou-image-text">
                            {allBRedAmount}
                          </span>
                        </div>
                        <span
                          className={
                            allBRedWin ? "zero-value" : "zero-value hides"
                          }
                          style={{
                            position: "unset",
                            transform: "unset"
                          }}
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            className="zero-icon"
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      evt_status == "CLOSED"
                        ? "overlayRoulettelock-galaxy"
                        : "overlayaviatorx-galaxy hide"
                    }
                  >
                    <div style={{ textAlign: "center" }}>
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        data-testid="LockIcon"
                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                        style={{ width: "70px", filter: "invert(0)" }}
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="RBC-Jetx-RightPanel">
                <table className="RBC-Jetx-Table">
                  <thead>
                    <tr>
                      <th>Runner</th>
                      <th>Price</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody id="refreshhistory">
                    {betList &&
                      betList !== null &&
                      betList !== undefined &&
                      betList !== "" &&
                      betList.map((bet) => (
                        <tr>
                          <th style={{ textTransform: "uppercase" }}>
                            {bet.rnrname}
                          </th>
                          <th>{bet.rate}</th>
                          <th>{bet.lib}</th>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .zero-icon{
            width: 32px;
            height: 32px;
          }
          
          #BBlack .zero-value,
#ABlack .zero-value,
#ARed .zero-value,
#BRed .zero-value,
#A .zero-value,
#B .zero-value,
#APlus .zero-value,
#BPlus .zero-value,
#BGreater21 .zero-value,
#BLess21 .zero-value,
#BEqual21 .zero-value,
#AGreater21 .zero-value,
#ALess21 .zero-value,
#AEqual21 .zero-value {
    position: absolute;
    left: 50%;
    top: 35%;
    transform: translate(-50%, -50%);
    z-index: 999;
    pointer-events: none;
}

.runner-name {
  font-size: 12px;
  font-weight: bold;
  color: #FFD700;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
}
        `}
      </style>
    </GalaxyLayout>
  );
}
